export default {
  message: {
    booster_name: 'Booster naam',
    details: 'Details',
    back: 'Terug',
    exportDataTitle: 'Lijsten als Excel-bestand downloaden',
    mobile_phone: 'Mobiele telefoon',
    sales_representative: 'Vertegenwoordiger',
    commitment_letter_accept: 'Commitment letter accept',
    iban_number: 'IBAN',
    without_supplier: 'Zonder leverancier',
    price_in_euro: 'Prijs in €',
    is_default: 'Standaard',
    attribute_option: 'attribuut optie',
    image: 'afbeelding',
    show_stats_user: 'Winkelstatistieken - GEBRUIKER',
    shopUserStats: {
      pageTitle: 'Winkelstatistieken – Gebruikers',
      viewList: 'Statistieken bekijken',
      perPage: 'Rijen per pagina',
      searchPlaceholder: 'Zoeken op e-mail, klantnummer, bedrijf…',
      paginationSummary: '{from}–{to} van {total} (pagina {page} / {lastPage})',
      loadError: 'Winkelgebruikersstatistieken konden niet worden geladen.',
      exporting: 'Exporteren…',
      exportDone: 'Export voltooid ({rows} rijen).',
      exportFailed: 'Export mislukt.',
      exportPanel: {
        title: 'Excel-export',
        refreshStatus: 'Status vernieuwen',
        lastExport: 'Laatste export',
        lastPoint: 'Laatste punt',
        rowCount: 'Rijen',
        stateReadyFresh: 'Gegevens zijn actueel. U kunt de export downloaden.',
        stateReadyStale:
          'Puntenimport is nieuwer dan de laatste export. Download het vorige bestand of wacht op de volgende cyclus (elke 15 min).',
        stateWaitingRefresh: 'Nieuw bestand wordt gegenereerd…',
        stateNoFile: 'Exportbestand is nog niet beschikbaar.',
        firstFileEta: 'Eerste bestand verwacht rond {eta}.',
        downloadExcel: 'Excel downloaden',
        formatLabel: 'Formaat',
        formatXlsx: 'XLSX (.xlsx)',
        formatXls: 'XLS (.xls)',
        downloadLastFile: 'Laatste bestand downloaden',
        waitForUpdate: 'Wachten op update',
        refreshInProgress: 'Update bezig…',
        downloadSuccess: 'Bestand gedownload.',
        downloadUpdatedSuccess: 'Bijgewerkt bestand gedownload.',
        downloadRunning: 'Update bezig, probeer het zo opnieuw.',
        downloadNotReady: 'Bestand nog niet klaar. Volgende poging rond {eta}.',
        waitTimeout: 'Time-out bij wachten op nieuwe export.',
        statusLoadFailed: 'Exportstatus laden mislukt.',
        staleConfirmTitle: 'Oudere export downloaden?',
        staleConfirmBody: 'Het bestand is van {exportAt}, punten zijn bijgewerkt op {pointAt}. Doorgaan?'
      }
    },
    is_manual_order: 'Is een handmatige bestelling',
    supplier_id: 'Leverancier ID',
    vendor_id: 'Fabrikant-ID',
    archive_at: 'Archief',
    exported_bridgestone: 'Exportiert Bridgestone',
    exported_engelbert: 'Exportiert Engelbert Strauß',
    exported_prime: 'Exportiert PrämieDirekt',
    exported_other: 'Andere geëxporteerd',
    product_variant_id: 'Productvariant-ID',
    cancelled_at: 'Geannuleerd om',
    shipped_at: 'Verzonden om',
    product_id: 'Product-ID',
    quantity: 'Hoeveelheid',
    qty: 'Hoeveelheid',
    action_text: 'URL-tekst',
    action_url: 'URL',
    token: 'UUID',
    marketing_option: 'Marketingoptie',
    parent_id: 'Ouder ID',
    parent_name: 'Naam ouder',
    approval_id: 'Goedkeurings-id',
    wholesaler_id: 'Wholesaler id',
    cart_id: 'Winkelwagen-ID',
    order_date: 'Besteldatum',
    order_number: 'Bestellingsnummer',
    accept_date: 'Datum accepteren',
    wholesaler_dealer_id: 'Wholesaler dealer id',
    dealer_id: 'Dealer id',
    is_partial_delivery: 'Betreft gedeeltelijke levering',
    order_completed: 'Bestelling voltooid',
    order_cancelled: 'Bestelling geannuleerd',
    date_delivery: 'Bezorgdatum',
    published: 'Publiceren',
    properties: 'Eigenschappen',
    group: 'Groepsnaam',
    gka: 'GKA',
    publish_at: 'Publiceren',
    video: 'Video URL',
    training_id: 'Trainings-ID',
    correct: 'Is juist?',
    question_id: 'Vraag-ID',
    body: 'Inhoud',
    size: 'Lettergrootte',
    platform: 'Besturingssysteem',
    is_added: 'Actieve booster',
    numberOfSetsOfSeasonalTiresBudget: 'opslag per jaar',
    distributionWinter: 'Winter',
    distributionSummer: 'Zomer',
    overEighteenInch: '≥ 18 inch (in %)',
    tireSalesNumber: 'Banden per jaar',
    distributionAll: 'All season',
    budgetPremium: 'Premium',
    postal_code: 'Postcode',
    legalForm: 'Wettelijk document',
    budgetMid: 'Middenklasse',
    budgetLow: 'Budget',
    group_id: 'Groeps-ID',
    website: 'website',
    customer_number: 'Klantnummer',
    user_id: 'gebruikersnaam',
    browser: 'webbrowser',
    ip: 'IP adres',
    email_verified_at: 'e-mailadres geverifieerd op',
    last_login: 'Laatste aanmelding',
    deleted_at: 'verwijderd bij',
    is_active: 'Is actief?',
    old: 'Oud',
    selectBooster: 'Selecteer een booster',
    activeBooster: 'Actieve booster',
    activeBoosterText: 'Wilt u een booster voor de gebruiker activeren?',
    activeBoostersOne: 'Ga je deze booster voor iedere gebruiker activeren?',
    activeBoostersSalesDataWarning:
      'Zorg ervoor dat de verkoopgegevens die u wilt boosten de definitieve verkoopcijfers zijn en in de toekomst niet meer worden gewijzigd. Anders kunnen er afwijkingen in de berekeningen ontstaan. Deze actie kan niet ongedaan worden gemaakt.',
    sum: 'Som',
    boosterOnTop: 'Boosterpunten (bovenaan)',
    relevantBoosterPoints: 'Relevante boosterpunten',
    totalBefore: 'Puntentotaal voorheen',
    standardPoints: 'Standaard punten',
    standard: 'Standaard',
    boosterPoints: 'Boosterpunten',
    allPoints: 'Alle punten',
    pointsByUser: 'Punten per gebruiker downloaden',
    pointsByGroup: 'Punten per groep downloaden',
    allKickbacks: 'Alle Bonuses',
    kickbackByUser: 'Bonus per gebruiker downloaden',
    kickbackByGroup: 'Bonus per groep downloaden',
    pointsImportFileInfo: 'In het bestand moet kolom 1 e-mail zijn en kolom 2 punten.',
    pointsImportHeaderInfo:
      'De eerste rij moet de kopteksten bevatten: Email en Points. De gegevens moeten vanaf de tweede rij beginnen.',
    pointsImportValueInfo:
      'De puntenwaarden in het bestand moeten positief of negatief zijn. Als iemand punten wil toevoegen, moet het bestand positieve waarden bevatten. Als iemand punten wil aftrekken, moet het bestand negatieve waarden bevatten.',
    pointsImportTitle: 'Punten importeren uit Excel-bestand',
    pointsImportFailed: 'Importeren mislukt',
    pointsImportSummaryTitle: 'Importoverzicht',
    pointsImportProcessed: 'Verwerkt',
    pointsImportInvalidFile: 'Alleen Excel-bestanden (.xlsx, .xls) zijn toegestaan.',
    pointsImportPreviewLoading: 'Bestandsvoorbeeld wordt voorbereid...',
    pointsImportPreviewCount: 'Toont {shown} van {count} rijen uit het bestand.',
    pointsImportPreviewEmpty: 'Het geselecteerde bestand bevat geen rijen om te importeren.',
    pointsImportPreviewError: 'Het geselecteerde Excel-bestand kon niet worden gelezen.',
    pointsImportDateInfo:
      'De geselecteerde datum wordt gebruikt als de datum waarop de punten op het gebruikersaccount ontstaan. Dit kunnen ook punten uit het verleden zijn.',
    loginAs: 'Log in als gebruiker',
    positionX: 'Positie x',
    positionY: 'Positie y',
    textSize: 'Lettergrootte',
    text: 'Tekst',
    publish: 'Publiceren',
    certificate: 'Certificaat',
    certificatePdf: {
      title: 'CERTIFICAAT',
      tookPartInCourse: 'heeft deelgenomen aan de cursus:',
      courseDetails: 'Cursusdetails'
    },
    remove_cs_number: 'Weet u zeker dat u het klantnummer {customerNumber} ({wholesaler}) wilt verwijderen?',
    keep_previous_year_points: 'Punten van voorgaande jaren behouden na het verwijderen van het klantnummer',
    keep_previous_year_points_warning:
      'If you select this option, deleting the customer number will remove only points from the current year. Points from previous years will remain, so older balances and reports may still include data linked to this customer number. Select this only if you want to keep past years unchanged.',
    remove_order: 'Weet u zeker dat u de bestelling wilt verwijderen?',
    is_internal: 'Is interne gebruiker?',
    selectAddressBtn: 'Selecteer adres',
    currentBasket: 'Huidige mand',
    loginEmail: 'Log in',
    tenantEmailType: 'E-mailtype',
    tenantEmailAddNew: 'Nieuw e-mailadres toevoegen',
    tenantEmailTypeFinancial: 'Voor financiële informatie (o.a. bonusspecificatie)',
    tenantEmailTypeMarketing: 'Voor Bridgestone Plus marketingcommunicatie (o.a. acties/nieuwsbrieven)',
    open_new_tab: 'Openen in nieuw tabblad?',
    newTabLabel: 'Nieuw tabblad',
    file: 'Bestand',
    company_name: 'Bedrijfsnaam',
    partner_name: 'Contactpersoon',
    boosterImport: {
      label: 'CSV-bestand.'
    },
    event: 'Evenement',
    created_at: 'Creatiedatum',
    done_by: 'Uitgevoerd door',
    authors: 'Uitgevoerd door',
    changes: 'Wijzigingen',
    modified_user: 'Betrokken gebruiker',
    modified_users: 'Betrokken gebruikers',
    dealer: 'Dealer',
    dealers: 'Car Dealer / Tyre Dealer',
    activity: 'Activiteit',
    logs: 'Logboeken',
    full_text_search: 'Zoek volledige text',
    booster_wholesaler: 'Groothandelaar',
    booster_saison: 'Seizoen',
    booster_create: 'Booster maken',
    booster_brands: 'Merken',
    booster_motor: 'Motor',
    booster_message_title: 'Berichttitel',
    booster_delete_points: 'Punten verwijderen',
    booster_delete_points_confirm:
      'Weet u zeker dat u deze boosterpunten wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    booster_from: 'Datum vanaf',
    booster_to: 'Datum tot',
    boosterList: {
      seasons: 'Seizoenen',
      usersAmount: 'Aantal gebruikers',
      factor: 'Factor',
      calculateBoosters: 'Boosters berekenen',
      calculateBoostersConfirmTitle: 'Boosters berekenen?',
      calculateBoostersConfirm:
        'Hiermee wordt de berekening van boosterpunten gestart voor passende gebruikers op basis van deze boosterconfiguratie. Dit kan enige tijd duren. De resultaten verschijnen in de boostervoorbeeldweergave, waar u ze kunt controleren en accepteren of de berekende punten kunt verwijderen. Na afronding van de berekening is bewerken van deze booster mogelijk niet meer mogelijk. Wilt u doorgaan?',
      showAll: 'Alles tonen (+{count})',
      showLess: 'Minder tonen'
    },
    booster_tires: 'Banden',
    booster_products: 'Productnamen',
    booster_customers: 'Klantnummers',
    booster_factor: 'Faktor',
    booster_ipcs: "IPC's",
    boosterIpcsImport: {
      button: "IPC's uploaden uit Excel",
      hint: 'Kolom A, .xlsx/.xls-bestand',
      emptySheet: 'Leeg werkblad.',
      emptyColumn: 'Geen gegevens in kolom A.',
      spacesError: "Ongeldige IPC's (bevatten spaties): {items}",
      invalidFormatError: 'Ongeldig IPC-formaat (alleen cijfers): {items}',
      requestValidationError: 'Validatiefout in request.',
      unknownError: "Onbekende IPC's: {items}",
      success: "IPC's geïmporteerd: {count}",
      readError: 'Kon IPC-bestand niet lezen.'
    },
    booking: 'Boeking',
    select: 'Selecteer alstublieft',
    preview: 'Voorbeeld',
    credit: 'Credit',
    deduction: 'Debet',
    subject: 'Onderwerp',
    customerNumber: 'Klantnummer',
    search: 'Zoek',
    customer_nr_name: 'Klantnummer/naam',
    selectAll: 'Alles selecteren',
    deselectAll: 'Alles deselecteren',
    generateReport: {
      selectAll: 'Alles selecteren',
      reset: 'Filters resetten',
      loadingInfo: 'Rapport wordt gegenereerd, even geduld...',
      generate: 'Rapport genereren',
      validation: {
        distributorRequired: 'Selecteer minimaal een distributeur.'
      },
      personal_data: {
        title: 'Persoonlijke gegevens',
        email: 'E-mail',
        salutation: 'Aanhef',
        first_name: 'Voornaam',
        last_name: 'Achternaam',
        job_position: 'Functie in het bedrijf'
      },
      shipping_address: {
        title: 'Leveringsadres',
        company: 'Bedrijfsnaam',
        street: 'Huisnummer en straat',
        postal_code: 'Postcode',
        mobile_phone: 'Mobiele telefoon',
        iban_number: 'IBAN',
        vat: 'Btw-nummer',
        city: 'Plaats'
      },
      operating_data: {
        title: 'Operationele gegevens',
        customer_number: 'Klantnummer',
        group: 'Network',
        first_registration: 'Eerste registratie',
        last_login: 'Laatste aanmelding',
        tires_per_year: 'Banden per jaar',
        over_18_inch: 'Meer dan 18 inch',
        premium: 'Premium',
        middle: 'Middenklasse',
        summer: 'Zomer',
        winter: 'Winter',
        all_season: 'All season',
        major: 'Groep',
        customer_group: 'Groep'
      },
      calculated_data: {
        title: 'Berekende gegevens',
        tireAmount: 'Aantal banden',
        points: 'Punten',
        bonus: 'Bonus'
      },
      sales_structure: {
        title: 'Verkoopstructuur',
        distributor: {
          title: 'Distributeur'
        },
        sales_representative: {
          title: 'Vertegenwoordiger'
        },
        wholesaler: {
          title: 'Groothandel'
        },
        dealer: {
          title: 'Dealer'
        }
      },
      meta: {
        title: 'Metadata',
        brand: {
          title: 'Merk',
          BS: 'BS',
          FS: 'FS'
        },
        year: {
          title: 'Jaar'
        },
        calendarMonth: {
          title: 'Kalendermaand',
          january: 'Januari',
          february: 'Februari',
          march: 'Maart',
          april: 'April',
          may: 'Mei',
          june: 'Juni',
          july: 'Juli',
          august: 'Augustus',
          september: 'September',
          october: 'Oktober',
          november: 'November',
          december: 'December'
        }
      }
    },
    import: 'Importeren',
    rows: 'Rijen',
    message: 'Bericht',
    articleNumber: 'Artikel nummer',
    inform_user: 'Om klanten te informeren',
    leaveComment: 'Laat hier een reactie achter',
    user_new: 'Nieuwe gebruiker',
    actions: 'Acties',
    residence: 'Is woonplaats',
    emailVerified: 'E-mailadres geverifieerd op',
    optinAt: 'Aanmelden bij',
    registerAt: 'Schrijf je in bij',
    street: 'Huisnummer en straat',
    country: 'Land',
    postalcode: 'Postcode',
    city: 'Plaats',
    suffix: 'Adresachtervoegsel',
    fax: 'Fax',
    date: 'Datum',
    optinToken: 'OptIn-Token',
    title: 'Titel',
    subtitle: 'Ondertitel',
    phone: 'Telefoon',
    company: 'Bedrijfsnaam',
    forename: 'Voornaam',
    lastname: 'Achternaam',
    language: 'Taal',
    salutation: 'Aanhef',
    userData: 'Gebruikersgegevens',
    clientType: 'Klanttype',
    carDealer: 'Autodealer',
    tyreDealer: 'Bandenhandelaar',
    teamLkw: 'Team LKW',
    teamEmOtr: 'Team EM/OTR',
    teamFarmTractor: 'Team landbouwtractor',
    teamBandag: 'Team Bandag',
    chooseDots: 'Kies..',
    both: 'Beide',
    contact_service: {
      is_main: 'Is hoofdcontact?',
      direct: 'Direct',
      indirect: 'Indirect'
    },
    fileChoose: 'Bestand kiezen',
    fileNoSelected: 'Geen bestand geselecteerd',
    loadingFile: 'Bestand wordt geladen...',
    only_points_payment: 'Alleen puntenbetaling',
    column: 'Kolom',
    csvOnly: 'Alleen CSV-bestanden zijn toegestaan.',
    milestoneUsers: {
      csvImportTitle: 'CSV-import',
      csvFormatHint: 'CSV-formaat: <code>email,milestone</code> (header optioneel)',
      importErrorsTitle: 'Importfouten',
      errorLine: 'Regel {line}: {message}',
      importFinished: 'CSV-import voltooid.'
    },
    kickbackPayoutReady: 'Formulier klaar om te verzenden. Geselecteerd bestand:',
    kickbackPayoutCsvInstruction:
      'Het CSV-bestand moet twee kolommen bevatten: de eerste met e-mail, de tweede met bonuswaarde in EUR.',
    kickbackPayoutCsvHeaderInvalid:
      'Ongeldige CSV-header. Eerste kolom moet Email zijn, tweede in formaat Bonus <nummer> (bijv. Bonus 25).',
    kickbackPayoutCsvTwoColumnsOnly: 'CSV moet precies twee kolommen bevatten: Email en getal.',
    kickbackPayoutCsvEmailNumberInvalid: 'Ongeldige CSV-gegevens. Eerste kolom moet een e-mailadres zijn, tweede een getal.',
    kickbackPayoutCsvBonus: 'CSV-bonus',
    kickbackPayoutKickBackFeeSum: 'Kickback som',
    kickbackPayoutYear: 'Jaar',
    kickbackPayoutMissingEmails: 'Ontbrekende e-mails:',
    kickbackPayoutCsvFile: 'CSV',
    kickbackPayoutCsvContent: 'CSV-inhoud',
    kickbackPayoutAllTranslationsRaw: 'Alle vertalingen (raw)',
    multiplicator: {
      goals: {
        loyal: 'Loyaal',
        bronze: 'Brons',
        silver: 'Zilver',
        gold: 'Goud',
        platinum: 'Platina'
      }
    },
    importSchemaNotLoaded: 'Importschema is niet geladen.',
    csvHeaderEmpty: 'CSV-kop is leeg.',
    csvHeaderMismatch: 'CSV-kop komt niet overeen bij kolom {index}: verwacht "{expected}", gekregen "{actual}".',
    csvHeaderMismatchTitle: 'CSV-kop komt niet overeen',
    csvColumnCountMismatchTitle: 'CSV-kolomaantal komt niet overeen',
    csvColumnCountMismatch: 'Rij {row}: verwacht {expected} kolommen, gekregen {actual}.',
    csvHeaderColumnCountMismatch: 'Koprij: verwacht {expected} kolommen, gekregen {actual}.',
    step: 'Stap',
    profile: 'Profiel',
    addresses: 'Adressen',
    address: 'Adres',
    vendor_new: 'Nieuwe leverancier',
    supplier_new: 'Nieuwe leverancier',
    notAvailable: 'Beschikbaar',
    disabled: 'Uitgeschakeld',
    archived: 'Gearchiveerd',
    visible_not_allowed_to_buy: 'Zichtbaar, niet te koop',
    isDefault: 'Is standaard?',
    data: 'Gegevens',
    startImport: 'Begin met importeren',
    importText: 'Selecteer een bestand om te importeren:',
    importSchemaInfo: 'Het CSV-bestand moet de onderstaande velden in exact deze volgorde bevatten.',
    importConfirm: 'Bekijk hieronder de importvoorbeeldweergave. Wilt u doorgaan met de import?',
    importWholesalerHint: 'Optioneel. Indien geselecteerd worden klantnummers uit de CSV aan deze groothandelaar toegewezen.',
    importDownloadTemplate: 'Leeg CSV-sjabloon downloaden',
    importModalTitle: 'Gebruikers importeren via CSV',
    importStepSetup: 'Instellen',
    importStepPreview: 'Voorbeeld',
    importStepResult: 'Resultaat',
    importStepHelper: 'Download het sjabloon, vul uw gegevens in en upload het CSV-bestand.',
    importContextTitle: 'Importinstellingen',
    importRowsInFile: '{count} rijen in bestand',
    importValidating: 'Bestand valideren...',
    importPreviewLoading: 'Voorbeeld laden...',
    importSubmitting: 'Gebruikers importeren...',
    importStatsSuccess: 'Succes',
    importStatsError: 'Fouten',
    importStatsInfo: 'Info',
    importStatsOther: 'Overig',
    importShowSchema: 'Kolomschema tonen',
    importHideSchema: 'Kolomschema verbergen',
    importPreviewChangesCount: '{count} veldwijzigingen',
    importDropzoneTitle: 'Sleep CSV-bestand hierheen',
    importDropzoneHint: 'of klik om een bestand te kiezen',
    importSelectClientTypeForPreview: 'Bestand lijkt geldig ({count} rijen). Selecteer klanttype om het voorbeeld te laden.',
    importFileValid: 'Bestand succesvol gevalideerd ({count} rijen).',
    importLoadPreview: 'Voorbeeld laden',
    importPreviewFilterErrors: 'Fouten',
    importPreviewRowError: 'Fout',
    importPreviewFailed: 'Importvoorbeeld kon niet worden geladen.',
    importPreviewSummary: 'Samenvatting',
    importPreviewTotalRows: 'Totaal rijen',
    importPreviewNewUsers: 'Nieuwe gebruikers',
    importPreviewUpdatedUsers: 'Bijgewerkte gebruikers',
    importPreviewSkippedRows: 'Overgeslagen rijen',
    importPreviewErrors: 'Fouten',
    importPreviewNewCustomerGroups: 'Nieuwe klantgroepen',
    importPreviewNewStaffUsers: 'Nieuwe vertegenwoordigers',
    importPreviewAction: 'Actie',
    importPreviewIncoming: 'Inkomend',
    importPreviewCreates: 'Aanmaken',
    importPreviewUpdates: 'Bijwerken',
    importPreviewFieldChanges: 'Veldwijzigingen',
    importPreviewFieldColumn: 'Veld',
    importPreviewCurrentValue: 'Huidig',
    importPreviewFromFile: 'Uit bestand',
    importPreviewAfterImport: 'Na import',
    importPreviewNewValue: 'Nieuw',
    importPreviewWillChange: 'Wordt gewijzigd',
    importPreviewDiffersInFile: 'Verschilt in bestand',
    importPreviewOnlyWithChanges: 'Alleen rijen met wijzigingen',
    importPreviewFilterAll: 'Alle rijen',
    importPreviewShowDetails: 'Details',
    importPreviewBackToList: 'Terug naar lijst',
    importPreviewHideDetails: 'Details verbergen',
    importPreviewNoFilterResults: 'Geen rijen komen overeen met de geselecteerde filters.',
    importPreviewRowDetails: 'Rijdetails',
    importPreviewPlannedChanges: 'Geplande wijzigingen',
    importPreviewExistingData: 'Huidige gegevens in het systeem',
    importPreviewFullComparison: 'Volledige vergelijking',
    importPreviewNoExistingData: 'Geen bestaande gegevens (nieuwe gebruiker).',
    importPreviewNoFieldDetails: 'Geen velddetails beschikbaar voor deze rij.',
    importPreviewCustomerGroups: 'Klantgroepen',
    importPreviewExistingCustomerGroups: 'Bestaande groepen',
    importPreviewActionCreate: 'Aanmaken',
    importPreviewActionUpdate: 'Bijwerken',
    importPreviewActionUnchanged: 'Ongewijzigd',
    importPreviewActionSkip: 'Overslaan',
    importPreviewNoCreates: 'Er wordt niets nieuws aangemaakt',
    importPreviewNoUpdates: 'Geen velden worden bijgewerkt',
    importPreviewNoRowDetails: 'De samenvatting is beschikbaar, maar rijdetails konden niet worden geladen.',
    importPreviewDuplicateInFile: 'Duplicaat in bestand',
    importSuccess: 'Import succesvol uitgevoerd',
    importErrors: 'Importfouten',
    exportText: 'Select the option you want to export:',
    upload: 'Uploaden',
    vat: 'Btw-nummer',
    uploadText: 'Upload een afbeelding',
    users: 'Gebruikers',
    save: 'Opslaan',
    saving: 'Opslaan...',
    downloadOrderStats: 'Statistieken downloaden',
    downloadProductStats: 'Productstatistieken downloaden',
    category: 'Categorie',
    order: 'Volgorde',
    permissions: 'Machtigingen',
    edit_permissions_title: 'Machtigingen bewerken',
    permission: 'Machtiging',
    options: 'Opties',
    attributes: 'Kenmerk',
    add_attribute: 'Attribuut toevoegen',
    login: 'Inloggen',
    logout: 'Uitloggen',
    email: 'E-mail',
    username: 'Gebruikersnaam',
    type: 'Type',
    status: 'Status',
    filter: 'Filter',
    name: 'Naam',
    remove: 'Verwijderen',
    points: 'Punten',
    description: 'Omschrijving',
    short_description: 'Korte beschrijving',
    count: 'aantal',
    action: 'Actie',
    role: 'Rol',
    sku: 'SKU',
    main: 'Hoofdproduct',
    variant: 'Productvariant',
    active: 'Actief',
    activeLabel: 'Actief',
    vendor: 'Verkoper',
    supplier: 'Leverancier',
    images: 'Afbeeldingen',
    upload_text: "Upload productfoto's",
    user: 'Gebruiker',
    roles: 'Rollen',
    search_products: 'Zoek producten',
    search_orders: 'Zoek bestellingen',
    search_type: 'Zoektype',
    hunter_new: 'Nieuwe hunter',
    first_name: 'Voornaam',
    last_name: 'Achternaam',
    social_security_number: 'Burgerservicenummer',
    place_of_birth: 'Geboorteplaats',
    date_of_birth: 'Geboortedatum',
    copy: 'Kopiëren',
    add_empty_variant: 'Lege variant toevoegen',
    activated: 'Geactiveerd',
    points_exporter_users_with_available_points: 'Gebruikers met beschikbare punten',
    points_exporter_unlocked_points: 'Export van gebruikers met ontgrendelde punten',
    points_exporter_date_label: 'Datum',
    start_date: 'Startdatum',
    end_date: 'Einddatum',
    points_exporter_download_button: 'Excel downloaden',
    menu: {
      customerGroup: {
        new: 'Nieuwe klantgroep',
        list: 'Klantgroepenlijst'
      },
      shopLimits: 'Shop limits',
      default_banners: 'Default banners',
      import_adex: 'Adex import',
      adex: 'Adex',
      messages_new: 'Nieuw bericht',
      messages_list: 'Lijst',
      logs: 'Logs',
      activities: 'Activiteiten',
      customer: 'Klant',
      booster_setup: 'Booster-instellingen',
      booster_list: 'Lijst',
      booster: 'Booster',
      points: 'Bonus-/puntenbeheer',
      cheques: 'Bonus-/puntenbeheer',
      'users-roles': 'Rollen en gebruikers',
      roles: 'Rollen',
      users: 'Gebruikers',
      users_list: 'Gebruikerslijst',
      milestone_users: 'Milestone gebruikers',
      shop_user_stats_list: 'Winkelgebruikersstatistieken',
      users_deleted: 'Verwijderde gebruikers',
      user_new: 'Nieuwe gebruiker toevoegen',
      perms: 'Machtigingen',
      'product-categories': 'Categorieën en producten',
      categories: 'Categorieën',
      categories_list: 'Categorieënlijst',
      category_new: 'Nieuwe categorie toevoegen',
      orders: 'Bestellingen',
      products: 'Producten',
      products_list: 'Productenlijst',
      product_new: 'Nieuw enkelvoudig product toevoegen',
      product_new_variants: 'Nieuw product met varianten',
      attributes: 'Kenmerk',
      attributes_list: 'Kenmerklijst',
      attribute_new: 'Nieuw kenmerk toevoegen',
      options_list: 'Optielijst',
      options_new: 'Nieuwe optie toevoegen',
      options: 'Opties',
      vendors: 'Verkopers',
      vendors_list: 'Verkoperslijst',
      vendor_new: 'Nieuwe verkoper toevoegen',
      suppliers: 'Leveranciers',
      suppliers_list: 'Leverancierslijst',
      supplier_new: 'Nieuwe leverancier toevoegen',
      sliders: 'Sliders',
      sliders_list: 'Sliderslijst',
      slider_new: 'Nieuwe slider toevoegen',
      featured: 'Uitgelichte producten',
      commands: "Commando's",
      command_ipc: 'IPC',
      exports: 'Exports',
      command_users: 'Gebruiker importeren',
      'trainings-schulungen': 'Trainingen',
      trainings: 'Producttrainingen',
      trainings_list: 'Lijst',
      training_new: 'Nieuwe toevoegen',
      btrainings_list: 'Lijst',
      btraining_new: 'Nieuwe toevoegen',
      btrainings: 'BS-trainingen',
      management: 'Contentbeheer',
      textpages: "Tekstpagina's",
      textpages_list: "Lijst met tekstpagina's",
      text_page_new: 'Nieuwe tekstpagina toevoegen',
      marketing_consents: 'Marketing toestemmingen',
      marketing_consents_list: 'Lijst toestemmingen',
      marketing_consents_edit: 'Toestemming bewerken',
      settings: 'Berichtenbeheerder',
      messages: 'Berichten',
      threads: 'Threads',
      requests: 'Gebruikersaanvragen',
      product_trainings_request: 'Aanvragen voor producttrainingen',
      bridgestone_courses_request: 'Aanvragen voor Bridgestone-cursussen',
      external_trainings_request: 'Aanvragen voor externe trainingen',
      hunter_request: 'Hunter',
      investments_request: 'Investeringsondersteuning',
      news_feed: 'Nieuwsfeed',
      news_feed_list: 'Nieuwslijst',
      news_feed_new: 'Nieuw nieuws toevoegen',
      salespromotions: 'Verkoopacties',
      promotions: 'Promoties',
      promotions_list: 'Lijst',
      promotions_new: 'Nieuwe',
      imported_products: 'Geïmporteerde producten',
      ipcs_list: 'IPC-lijst',
      hunter_list: 'Hunterlijst',
      hunters: 'Hunters',
      hunter_new: 'Nieuwe Hunter',
      groups_list: 'Netwerklijst',
      parent_attributes: 'Type',
      groups: 'Netwerk',
      group_new: 'Nieuwe',
      history: 'Aanmeldeverlauf',
      history_list: 'Aanmeldgeschiedenis',
      prices: 'Prijzenlijsten',
      prices_list: 'Lijst',
      price_new: 'Nieuwe prijslijst',
      price_categories: 'Prijzenlijsten',
      price_categories_list: 'Lijst',
      price_categories_new: 'Nieuwe prijslijst',
      inactive_users: 'Inactieve gebruikers',
      customer_numbers_to_approve: 'Nieuwe registraties<br/>zonder nummer',
      complaints_list: ' klachten',
      orders_list: 'Lijst',
      orders_new: 'Nieuwe bestelling',
      points_list: 'Puntenlijst',
      kickback_list: 'Bonus in Euro',
      booster_preview: 'Voorbeeld',
      'products-categories': 'Categorieën en producten',
      frontend_menu: 'Frontend-menu',
      frontend_menu_list: 'Lijst',
      frontend_menu_new: 'Nieuwe',
      'customer-groups': 'Klantgroepen',
      'customer-groups-list': 'Klantgroepenlijst',
      'customer-groups-new': 'Nieuwe klantgroep',
      kickback_payout: 'Bonusuitbetaling in euros',
      mediapages: 'Media Pages',
      mediapages_list: 'Lijst',
      media_page_new: 'New',
      uberall_request: 'Uberall',
      history_hour: 'Inloguren',
      wholesaler_management: 'Distributeurs management',
      in_active_cs_nr: 'Gedeactiveerde nummers',
      mediapages_file_list: 'bestandslijst',
      vouchers: 'Vouchers',
      vouchers_list: 'Lijst',
      vouchers_new: 'Nieuwe',
      brochure_prices_list: 'Lijst',
      brochure_prices: 'Productbrochures & prijslijsten',
      brochure_prices_new: 'Nieuw',
      brochure_file_list: 'Bestandenlijst',
      main_boxes: 'Teaser Boxes',
      main_boxes_list: 'Lijst',
      main_box: 'Bewerken',
      main_boxes_new: 'Nieuw',
      apps: 'Apps',
      apps_list: 'Lijst van apps',
      dealer_apps: 'Dealer-apps',
      about: 'Over ons-pagina',
      about_list: 'Lijst',
      about_new: 'Nieuw',
      about_edit: 'Bewerken',
      contact_service: 'Contact Service',
      contact_service_list: 'Lijst',
      contact_service_new: 'Nieuw',
      contact_service_edit: 'Bewerken',
      'hello-customer-survey': 'Hello Customer Survey',
      surveys_list: 'Surveys List',
      survey_new: 'Add New Survey',
      points_exporter: 'Points Exporter',
      points_exporter_export: 'Export',
      points_exporter_date_label: 'Date',
      points_exporter_download_button: 'Download',
      points_exporter_users_with_available_points: 'Users with available points',
      customer_numbers_assistant: 'Assistent voor klantnummers'
    },
    breadcrumb: {
      shopLimits: 'Shop limits',
      customer_numbers_assistant: 'Assistent voor klantnummers',
      in_active_cs_nr: 'Gedeactiveerde nummers',
      default_banners: 'Default banners',
      import_adex: 'Adex import',
      adex: 'Adex',
      history: 'Aanmeldeverlauf',
      activities: 'Activiteiten',
      customer: 'Klant',
      booster_setup: 'Booster-instellingen',
      booster_list: 'Lijst',
      booster: 'Booster',
      booster_edit: 'Bewerken',
      cheques: 'Bonus-/puntenbeheer',
      user_edit: 'Gebruiker bewerken',
      user_new: 'Nieuwe gebruiker',
      vendors: 'Verkopers',
      suppliers: 'Leveranciers',
      users: 'Gebruikers',
      user: 'Gebruiker',
      home: 'Home',
      perms: 'Machtigingen',
      roles: 'Rollen',
      roles_list: 'Lijst',
      dashboard: 'Dashboard',
      orders: 'Bestellingen',
      orders_edit: 'Bestelling bewerken',
      orders_view: 'Bestelling',
      orders_list: 'Bestellingen',
      salespromotions: 'Verkoopacties',
      promotions: 'Promoties',
      promotions_list: 'Lijst',
      promotions_new: 'Nieuwe',
      promotions_edit: 'Bewerken',
      salespromotions_list: 'Lijst',
      salespromotions_view: 'Weergeven',
      'products-categories': 'Bonuswinkel',
      categories: 'Categorieën',
      categories_list: 'Lijst',
      role: 'Rol',
      category: 'Categorie',
      marketing_consents: 'Marketing toestemmingen',
      marketing_consents_list: 'Lijst toestemmingen',
      marketing_consents_edit: 'Toestemming bewerken',
      products: 'Producten',
      products_list: 'Lijst',
      product: 'Product',
      product_new: 'Nieuw enkelvoudig product',
      product_new_variants: 'Nieuw product met varianten',
      product_variants: 'Product met varianten',
      product_category: 'Categorie-producten',
      attributes: 'Kenmerk',
      attributes_list: 'Lijst',
      attribute: 'Attribuut',
      category_new: 'Nieuwe categorie toevoegen',
      attribute_edit: 'Attribuut bewerken',
      options_new: 'Nieuwe optie',
      options: 'Opties',
      options_list: 'Lijst',
      userEdit: 'Gebruiker bewerken',
      users_list: 'Lijst',
      milestone_users: 'Milestone gebruikers',
      shop_user_stats_list: 'Winkelgebruikersstatistieken',
      users_deleted: 'Verwijderde gebruikers',
      vendor_new: 'Nieuwe verkoper',
      vendors_list: 'Lijst',
      vendor_edit: 'Verkoper bewerken',
      supplier_new: 'Nieuwe leverancier',
      suppliers_list: 'Lijst',
      supplier_edit: 'Leverancier bewerken',
      trainings: 'Trainingen',
      trainings_list: 'Lijst',
      btrainings: 'Online-trainingen',
      btrainings_list: 'Lijst',
      btraining: 'BS-training',
      training_new: 'Nieuwe training',
      btraining_new: 'Nieuwe BS-training',
      training_edit: 'Training bewerken',
      training: 'Training',
      command_ipc: 'IPC',
      exports: 'Exports',
      sliders: 'Sliders',
      sliders_list: 'Lijst',
      slider_new: 'Nieuwe slider',
      slider: 'Slider bewerken',
      command_users: 'Gebruikers importeren',
      textpages: "Tekstpagina's",
      text_page_new: 'Nieuwe tekstpagina',
      textpage: 'Tekstpagina',
      textpages_list: 'Lijst',
      messages: 'Berichten',
      messages_list: 'Lijst',
      messages_new: 'Nieuw bericht',
      messages_edit: 'Bericht bewerken',
      threads: 'Threads',
      featured: 'Uitgelichte producten',
      attribute_new: 'Nieuw kenmerk',
      product_trainings_request: 'Aanvragen voor producttrainingen',
      bridgestone_courses_request: 'Aanvragen voor BS-trainingen',
      external_trainings_request: 'Aanvragen voor externe trainingen',
      hunter_request: 'Hunter',
      investments_request: 'Investeringsondersteuning',
      news_feed: 'News feed',
      news_feed_list: 'Liste',
      news_feed_new: 'Nieuwe nieuwsfeed',
      news_feed_edit: 'Nieuwsfeed bewerken',
      news_feed_slider: 'Nieuwe slider voor nieuwsfeed',
      content: 'Inhoud',
      imported_products: 'Geïmporteerde producten',
      ipcs_list: 'IPC-lijst',
      hunter_list: 'Lijst',
      hunters: 'Hunters',
      hunter_new: 'Nieuwe Hunter',
      hunter_edit: 'Hunter bewerken',
      groups: 'Netwerk',
      groups_list: 'Netwerklijst',
      parent_attributes: 'Type',
      group_new: 'Nieuwe groep',
      group_edit: 'Groep bewerken',
      history_list: 'Aanmeldgeschiedenis',
      history_view: 'Aanmeldgeschiedenis van gebruiker',
      prices: 'Prijzenlijsten',
      prices_list: 'Lijst',
      price_new: 'Nieuwe prijslijst',
      price: 'Prijs bewerken',
      price_categories: 'Prijzenlijsten',
      price_categories_list: 'Lijst',
      price_categories_new: 'Nieuwe prijslijst',
      price_category: 'Prijzenlijst',
      inactive_users: 'Inactieve gebruikers',
      inactive_users_list: 'Lijst',
      customer_numbers_to_approve: 'Nieuwe registraties zonder nummer',
      complaints: 'Klachten',
      complaints_list: 'Lijst',
      complaints_view: 'Klacht',
      orders_new: 'Nieuwe bestelling',
      points_list: 'Puntenlijst',
      kickback_list: 'Bonus in Euro',
      kickback_payout: 'Bonusuitbetaling in euros',
      booster_preview: 'Voorbeeld',
      frontend_menu: 'Frontend-menu',
      frontend_menu_list: 'Lijst',
      frontend_menu_new: 'Nieuwe',
      'customer-groups': 'Klantgroepen',
      'customer-groups-list': 'Klantgroepenlijst',
      'customer-groups-new': 'Nieuwe klantgroep',
      'customer-groups-edit': 'Klantgroep bewerken',
      customer_group_new: 'Nieuwe klantgroep',
      options_edit: 'Bewerk optie',
      mediapages: 'Media Pages',
      mediapages_list: 'Lijst',
      media_page_new: 'New',
      mediapage: 'Edit',
      uberall_request: 'Uberall',
      history_hour: 'Inloguren',
      wholesaler_management: 'Distributeurs management',
      mediapages_file_list: 'bestandslijst',
      vouchers: 'Vouchers',
      vouchers_list: 'Lijst',
      vouchers_new: 'Nieuwe',
      brochure_prices_list: 'Lijst',
      brochure_file_list: 'Bestandenlijst',
      brochure_prices: 'Productbrochures & prijslijsten',
      brochure_prices_new: 'Nieuw',
      main_boxes: 'Teaser Boxes',
      main_boxes_list: 'Lijst',
      main_box: 'Bewerken',
      main_boxes_new: 'Nieuw',
      'hello-customer-survey': 'Hello Customer Survey',
      surveys_list: 'Surveys List',
      survey_new: 'Add New Survey',
      apps_list: 'Lijst van apps',
      app_new: 'Nieuw',
      app: 'Bewerken',
      about: 'Over ons-pagina',
      about_list: 'Lijst',
      about_new: 'Nieuw',
      about_edit: 'Bewerken',
      contact_service: 'Contact Service',
      contact_service_list: 'Lijst',
      contact_service_new: 'Nieuw',
      contact_service_edit: 'Bewerken',
      survey: 'Survey',
      contact_service_description_list: 'Lijst met contactservicebeschrijvingen',
      contact_service_description_edit: 'Bewerk contactservicebeschrijving',
      contact_service_description_new: 'Nieuwe contactservicebeschrijving',
      points_exporter: 'Points Exporter',
      points_exporter_export: 'Export'
    },
    orders: {
      view: 'Bestelling',
      new: 'Nieuwe bestelling',
      list: 'Bestellingen',
      edit: 'Bestelling bewerken',
      number: 'Bestelnummer',
      date: 'Bestel datum',
      state: 'Bestel status',
      labels: {
        company: 'Bedrijf',
        name: 'Naam',
        street: 'Straat',
        postalCodeCity: 'Postcode / Stad',
        userPhone: 'Telefoon gebruiker',
        userEmail: 'E-mail gebruiker',
        orderPhone: 'Telefoon bestelling'
      },
      status: {
        created: 'Gemaakt',
        confirm_order: 'Bestelling bevestigen',
        ready_for_shipment: 'Klaar voor verzending',
        rejected: 'Afgewezen',
        processed: 'Verwerkt',
        shipped: 'Verzonden',
        returned: 'Geretourneerd',
        finished: 'Afgerond',
        deleted: 'Verwijderd'
      },
      cartQuantityIncreased: 'De producthoeveelheid in de winkelwagen is verhoogd.',
      cartQuantityDecreased: 'De producthoeveelheid in de winkelwagen is verlaagd.',
      confirmIncreaseItem: 'Weet u zeker dat u de hoeveelheid van dit product in de bestelling wilt verhogen?',
      confirmDecreaseItem: 'Weet u zeker dat u de hoeveelheid van dit product in de bestelling wilt verlagen?',
      confirmDeleteItem: 'Weet u zeker dat u dit product uit de bestelling wilt verwijderen?',
      deletedInfo: 'Deze bestelling is verwijderd op {date}',
      activityLogs: 'Wijzigingsgeschiedenis',
      quantityChanged: 'Aantal: {from} → {to}',
      itemRemoved: 'Niet leverbaar / verwijderd'
    },
    salespromotions: {
      view: 'Verkooppromotie',
      list: 'Verkooppromoties',
      premium: 'DRIVEOURBEST',
      guarantee: 'TYREPROTECT',
      bonusCampaign: 'REIFENHITS',
      advantage: 'VORTEILSAKTION'
    },
    countries: {
      ad: 'Andorra',
      ae: 'Verenigde Arabische Emiraten',
      af: 'Afghanistan',
      ag: 'Antigua en Barbuda',
      ai: 'Anguilla',
      al: 'Albanië',
      am: 'Armenië',
      ao: 'Angola',
      aq: 'Antarctica',
      ar: 'Argentinië',
      as: 'Amerikaans-Samoa',
      at: 'Oostenrijk',
      au: 'Australië',
      aw: 'Aruba',
      ax: 'Åland',
      az: 'Azerbeidzjan',
      ba: 'Bosnië en Herzegovina',
      bb: 'Barbados',
      bd: 'Bangladesh',
      be: 'België',
      bf: 'Burkina Faso',
      bg: 'Bulgarije',
      bh: 'Bahrein',
      bi: 'Burundi',
      bj: 'Benin',
      bl: 'Saint-Barthélemy',
      bm: 'Bermuda',
      bn: 'Brunei',
      bo: 'Bolivia',
      bq: 'Caribisch Nederland',
      br: 'Brazilië',
      bs: 'Bahama’s',
      bt: 'Bhutan',
      bv: 'Bouveteiland',
      bw: 'Botswana',
      by: 'Belarus',
      bz: 'Belize',
      ca: 'Canada',
      cc: 'Cocoseilanden',
      cd: 'Congo-Kinshasa',
      cf: 'Centraal-Afrikaanse Republiek',
      cg: 'Congo-Brazzaville',
      ch: 'Zwitserland',
      ci: 'Ivoorkust',
      ck: 'Cookeilanden',
      cl: 'Chili',
      cm: 'Kameroen',
      cn: 'China',
      co: 'Colombia',
      cr: 'Costa Rica',
      cu: 'Cuba',
      cv: 'Kaapverdië',
      cw: 'Curaçao',
      cx: 'Christmaseiland',
      cy: 'Cyprus',
      cz: 'Tsjechië',
      de: 'Duitsland',
      dj: 'Djibouti',
      dk: 'Denemarken',
      dm: 'Dominica',
      do: 'Dominicaanse Republiek',
      dz: 'Algerije',
      ec: 'Ecuador',
      ee: 'Estland',
      eg: 'Egypte',
      eh: 'Westelijke Sahara',
      er: 'Eritrea',
      es: 'Spanje',
      et: 'Ethiopië',
      fi: 'Finland',
      fj: 'Fiji',
      fk: 'Falklandeilanden',
      fm: 'Micronesia',
      fo: 'Faeröer',
      fr: 'Frankrijk',
      ga: 'Gabon',
      gb: 'Verenigd Koninkrijk',
      gd: 'Grenada',
      ge: 'Georgië',
      gf: 'Frans-Guyana',
      gg: 'Guernsey',
      gh: 'Ghana',
      gi: 'Gibraltar',
      gl: 'Groenland',
      gm: 'Gambia',
      gn: 'Guinee',
      gp: 'Guadeloupe',
      gq: 'Equatoriaal-Guinea',
      gr: 'Griekenland',
      gs: 'Zuid-Georgia en Zuidelijke Sandwicheilanden',
      gt: 'Guatemala',
      gu: 'Guam',
      gw: 'Guinee-Bissau',
      gy: 'Guyana',
      hk: 'Hongkong SAR van China',
      hm: 'Heard en McDonaldeilanden',
      hn: 'Honduras',
      hr: 'Kroatië',
      ht: 'Haïti',
      hu: 'Hongarije',
      id: 'Indonesië',
      ie: 'Ierland',
      il: 'Israël',
      im: 'Isle of Man',
      in: 'India',
      io: 'Brits Indische Oceaanterritorium',
      iq: 'Irak',
      ir: 'Iran',
      is: 'IJsland',
      it: 'Italië',
      je: 'Jersey',
      jm: 'Jamaica',
      jo: 'Jordanië',
      jp: 'Japan',
      ke: 'Kenia',
      kg: 'Kirgizië',
      kh: 'Cambodja',
      ki: 'Kiribati',
      km: 'Comoren',
      kn: 'Saint Kitts en Nevis',
      kp: 'Noord-Korea',
      kr: 'Zuid-Korea',
      kw: 'Koeweit',
      ky: 'Kaaimaneilanden',
      kz: 'Kazachstan',
      la: 'Laos',
      lb: 'Libanon',
      lc: 'Saint Lucia',
      li: 'Liechtenstein',
      lk: 'Sri Lanka',
      lr: 'Liberia',
      ls: 'Lesotho',
      lt: 'Litouwen',
      lu: 'Luxemburg',
      lv: 'Letland',
      ly: 'Libië',
      ma: 'Marokko',
      mc: 'Monaco',
      md: 'Moldavië',
      me: 'Montenegro',
      mf: 'Saint-Martin',
      mg: 'Madagaskar',
      mh: 'Marshalleilanden',
      mk: 'Noord-Macedonië',
      ml: 'Mali',
      mm: 'Myanmar (Birma)',
      mn: 'Mongolië',
      mo: 'Macau SAR van China',
      mp: 'Noordelijke Marianen',
      mq: 'Martinique',
      mr: 'Mauritanië',
      ms: 'Montserrat',
      mt: 'Malta',
      mu: 'Mauritius',
      mv: 'Maldiven',
      mw: 'Malawi',
      mx: 'Mexico',
      my: 'Maleisië',
      mz: 'Mozambique',
      na: 'Namibië',
      nc: 'Nieuw-Caledonië',
      ne: 'Niger',
      nf: 'Norfolk',
      ng: 'Nigeria',
      ni: 'Nicaragua',
      nl: 'Nederland',
      no: 'Noorwegen',
      np: 'Nepal',
      nr: 'Nauru',
      nu: 'Niue',
      nz: 'Nieuw-Zeeland',
      om: 'Oman',
      pa: 'Panama',
      pe: 'Peru',
      pf: 'Frans-Polynesië',
      pg: 'Papoea-Nieuw-Guinea',
      ph: 'Filipijnen',
      pk: 'Pakistan',
      pl: 'Polen',
      pm: 'Saint-Pierre en Miquelon',
      pn: 'Pitcairneilanden',
      pr: 'Puerto Rico',
      ps: 'Palestijnse gebieden',
      pt: 'Portugal',
      pw: 'Palau',
      py: 'Paraguay',
      qa: 'Qatar',
      re: 'Réunion',
      ro: 'Roemenië',
      rs: 'Servië',
      ru: 'Rusland',
      rw: 'Rwanda',
      sa: 'Saoedi-Arabië',
      sb: 'Salomonseilanden',
      sc: 'Seychellen',
      sd: 'Soedan',
      se: 'Zweden',
      sg: 'Singapore',
      sh: 'Sint-Helena',
      si: 'Slovenië',
      sj: 'Spitsbergen en Jan Mayen',
      sk: 'Slowakije',
      sl: 'Sierra Leone',
      sm: 'San Marino',
      sn: 'Senegal',
      so: 'Somalië',
      sr: 'Suriname',
      ss: 'Zuid-Soedan',
      st: 'Sao Tomé en Principe',
      sv: 'El Salvador',
      sx: 'Sint-Maarten',
      sy: 'Syrië',
      sz: 'Eswatini',
      tc: 'Turks- en Caicoseilanden',
      td: 'Tsjaad',
      tf: 'Franse Gebieden in de zuidelijke Indische Oceaan',
      tg: 'Togo',
      th: 'Thailand',
      tj: 'Tadzjikistan',
      tk: 'Tokelau',
      tl: 'Oost-Timor',
      tm: 'Turkmenistan',
      tn: 'Tunesië',
      to: 'Tonga',
      tr: 'Turkije',
      tt: 'Trinidad en Tobago',
      tv: 'Tuvalu',
      tw: 'Taiwan',
      tz: 'Tanzania',
      ua: 'Oekraïne',
      ug: 'Oeganda',
      uk: 'Verenigd Koninkrijk',
      um: 'Kleine afgelegen eilanden van de Verenigde Staten',
      us: 'Verenigde Staten',
      uy: 'Uruguay',
      uz: 'Oezbekistan',
      va: 'Vaticaanstad',
      vc: 'Saint Vincent en de Grenadines',
      ve: 'Venezuela',
      vg: 'Britse Maagdeneilanden',
      vi: 'Amerikaanse Maagdeneilanden',
      vn: 'Vietnam',
      vu: 'Vanuatu',
      wf: 'Wallis en Futuna',
      ws: 'Samoa',
      xk: 'Kosovo',
      ye: 'Jemen',
      yt: 'Mayotte',
      za: 'Zuid-Afrika',
      zm: 'Zambia',
      zw: 'Zimbabwe'
    },
    messages: {
      list: 'Berichten',
      new: 'Nieuw bericht',
      edit: 'Bericht bewerken',
      title: 'Titel',
      content: 'Inhoud',
      empty: 'Geen berichten',
      direct: 'Direct bericht',
      toDealers: 'Aan dealers',
      sendEmail: 'E-mail verzenden',
      selectWholesalers: 'Groothandelaars selecteren',
      directWholesaler: 'Van groothandel tot dealer',
      selectGroups: 'Groepen selecteren',
      directGroup: 'Naar dealergroepen',
      toGroups: 'Naar groepen',
      saveAndSend: 'Opslaan en verzenden',
      users: 'Selecteer gebruikers (min. 3 tekens)',
      sent: 'Verstuurd',
      externalTrainingPoints: 'Externe Training / Investeringspunten',
      externalTrainingBank: 'Eigenaar van externe training/beleggingsrekening',
      externalTrainingIBAN: 'Externe Opleiding / Investering IBAN',
      onlineTrainingTitle: 'Producttraining - Titel',
      onlineTrainingPoints: 'Onlinetraining - Punten',
      hunterTitle: 'Jager - Titel',
      hunterPoints: 'Jager - Punten',
      hunterPrice: 'Jager - Prijs',
      bTrainingTitle: 'BS-training - Titel',
      bTrainingPoints: 'BS v - Punten',
      pointsProfileComplete: 'Punten - Profiel voltooid',
      orderProducts: 'Producten in de bestelling'
    },
    messages_alert: {
      title: 'Verwijder bericht',
      desc: 'Wilt u het bericht echt verwijderen?'
    },
    groups_alert: {
      title: 'Groep verwijderen',
      desc: 'Wil je de groep echt verwijderen?'
    },
    vendors_alert: {
      title: 'Fabrikant verwijderen',
      desc: 'Wilt u de fabrikant echt verwijderen?'
    },
    suppliers_alert: {
      title: 'Leverancier verwijderen',
      desc: 'Wilt u de leverancier echt verwijderen?'
    },
    threads: {
      title: 'Draden',
      choose: 'Kies een bericht',
      order: 'Kies draad voor bestellingen',
      salespromotions: 'Kies een draad voor verkooppromoties',
      externalTraining: 'Kies draad voor externe trainingen',
      investment: 'Kies draad voor investering',
      onlineTraining: 'Kies een draad voor producttraining',
      bTraining: 'Kies draad voor BS Training',
      profileComplete: 'Kies draad voor Profiel compleet',
      activeUser: 'Actief gebruikersbericht'
    },
    userGroup: {
      parentAttributeName: 'Bovenliggend attribuut',
      name: 'Groepsnaam',
      gka: 'GKA',
      isMain: 'Is hoofdgroep?',
      dealersGroupTab: 'Dealergroep',
      dealersTab: 'Dealers',
      searchDealers: 'Zoek dealers'
    },
    customerGroup: {
      name: 'Naam van klantgroep'
    },
    categories: 'Categorieën',
    count_users: 'Tel gebruikers',
    count_perms: 'Machtigingen tellen',
    count_products: 'Aantal producten',
    count_files: 'Aantal bestanden',
    count_options: 'Aantal opties',
    product: 'Product',
    attribute_new: 'Nieuw kenmerk',
    product_new: 'Nieuw enkelvoudig product',
    product_new_variants: 'Nieuw product met varianten',
    training_new: 'Nieuwe training',
    btraining_new: 'Nieuwe BS-training',
    category_new: 'Nieuwe categorie toevoegen',
    category_title: 'Naam categorie',
    category_desc: 'Beschrijving categorie',
    category_image: 'Categorie-afbeelding',
    category_link: 'Categoriekoppeling',
    category_alert: {
      title: 'Categorie verwijderen',
      desc: 'Weet u zeker dat u de categorie wilt verwijderen?'
    },
    text_page_alert: {
      title: 'Tekstpagina verwijderen',
      desc: 'Weet u zeker dat u de tekstpagina wilt verwijderen?'
    },
    news_feed_alert: {
      title: 'Newsfeed verwijderen',
      desc: 'Weet u zeker dat u de newsfeed "{title}" wilt verwijderen?'
    },
    newsFeedList: {
      perPage: 'Items per pagina',
      loading: 'Newsfeeds laden…',
      paginationSummary: '{from}–{to} van {total} (pagina {page} / {lastPage})',
      moveUp: 'Omhoog',
      moveDown: 'Omlaag'
    },
    ipcList: {
      title: 'IPC-lijst',
      perPage: 'Rijen per pagina',
      clearFilters: 'Filters wissen',
      loading: 'IPCs laden…',
      accessDenied: 'U heeft geen toestemming om de IPC-lijst te bekijken.',
      paginationSummary: '{from}–{to} van {total}',
      columns: {
        material: 'Materiaal / IPC',
        detailed_brand: 'Gedetailleerd merk',
        tyre_size_designation: 'Bandenmaat',
        new_budget_category: 'Budgetcategorie',
        service_description: 'Servicebeschrijving',
        rim: 'Velg',
        marketing_product_brand: 'Marketingmerk',
        marketing_product_name: 'Marketingproductnaam'
      }
    },
    slider_alert: {
      title: 'Slider verwijderen',
      desc: 'Weet u zeker dat u de slider "{title}" wilt verwijderen?'
    },
    question_alert: {
      title: 'Delete Question',
      desc: 'Do you really want to delete the question?'
    },
    certificate_alert: {
      title: 'Delete Certificate Text',
      desc: 'Do you really want to delete the certificate text?'
    },
    product_alert: {
      title: 'Categorie verwijderen',
      desc: 'Weet u zeker dat u de categorie wilt verwijderen?'
    },
    survey_alert: {
      title: 'Survey verwijderen',
      desc: 'Weet u zeker dat u de survey wilt verwijderen?'
    },
    cancel: 'Annuleren',
    confirm: 'Bevestigen',
    training_edit: 'Training bewerken',
    options_new: 'Nieuwe optie',
    options_edit: 'Bewerk optie',
    subcategory: 'Subcategorie',
    importStarted: 'Het importeren is gestart',
    connection: 'Verbinding',
    variants: 'Varianten',
    add_variant: 'Variant toevoegen',
    vendors: 'Verkoper',
    suppliers: 'Verkoper',
    training: 'Opleiding',
    commands: {
      ipc: 'IPC-importeur',
      users: 'Importeur van gebruikers',
      exports: 'Exports'
    },
    userImport: {
      label: 'Alleen XLSX-type'
    },
    questions: 'Vragen',
    correctAnswer: 'Goed antwoord',
    validation: {
      required: 'Veld is verplicht'
    },
    edit_question: 'Vragen bewerken',
    edit_btraining_Detail: 'Bewerk BS-trainingsdetails',
    video_url: 'Video URL',
    save_new_question: 'Nieuwe vraag opslaan',
    reward: 'Beloningsafbeelding - niet vereist',
    poster: 'Posterafbeelding',
    sliderImageValidation: 'Afbeelding moet 1600x1040 px zijn of 2x/3x/4x van dit formaat.',
    mainBoxImageValidation: 'Afbeelding moet 368x150 px zijn of 2x/3x/4x van dit formaat.',
    imageDimensions: 'Afbeeldingsafmetingen',
    season: 'Seizoen',
    answers: 'Antwoorden',
    training_details: 'Trainingsdetails',
    extras: 'Extra informatie',
    duration: 'Duur',
    price: 'Prijs',
    min_participant: 'Minimale deelnemers',
    max_participant: 'Maximale deelnemers',
    choose_trainingType: 'Kies trainingstype',
    update: 'Update',
    cost_type: 'Kostentype',
    save_detail: 'Details opslaan',
    slider_new: 'Nieuwe schuifregelaar',
    sliders: 'Schuifregelaars',
    groups: 'Network',
    slider: 'Schuifregelaar bewerken',
    choose_showHideText: 'Toon/verberg tekst',
    text_page_new: 'Nieuwe tekstpagina',
    text_pages: "Tekstpagina's",
    text_page: 'Tekstpagina',
    featured: {
      title: 'Uitgelichte producten',
      bestseller: 'Best verkocht',
      seasonal: 'Seizoensgebonden',
      affordable: 'Ontdek',
      autoBestsellers: 'Toon automatisch berekende bestsellers',
      affordableOffsetLabel: 'Maximale prijscompensatie',
      affordableLimitLabel: 'Weergaveproductenlimiet'
    },
    seasons: {
      all: 'All season',
      summer: 'Zomer',
      winter: 'Winter',
      general: 'Algemeen'
    },
    addAddress: 'Voeg adres toe',
    administration: 'Administratie',
    password: 'Wachtwoord',
    forcedPasswordChange: {
      title: 'Wijzig uw wachtwoord',
      description: 'Uw tijdelijke wachtwoord moet worden gewijzigd voordat u toegang krijgt tot de applicatie.',
      enterNewPassword: 'Voer nieuw wachtwoord in',
      repeatNewPassword: 'Herhaal nieuw wachtwoord',
      strengthLabel: 'Wachtwoordsterkte',
      submit: 'Wachtwoord wijzigen en inloggen',
      generatePassword: 'Sterk wachtwoord genereren',
      success: 'Wachtwoord is succesvol gewijzigd',
      loginAfterChangeFailed:
        'Het wachtwoord is gewijzigd, maar automatisch inloggen is mislukt. Log in met uw nieuwe wachtwoord.',
      sameAsTemporaryPassword: 'Het nieuwe wachtwoord mag niet hetzelfde zijn als het tijdelijke wachtwoord.',
      validationError: 'Corrigeer de wachtwoordvereisten voordat u doorgaat.',
      invalidToken: 'Uw wachtwoordsessie is verlopen. Log opnieuw in.',
      rules: {
        minLength: 'Minimaal 12 tekens',
        uppercase: 'Minimaal één hoofdletter',
        lowercase: 'Minimaal één kleine letter',
        digit: 'Minimaal één cijfer',
        special: 'Speciaal teken aanbevolen'
      }
    },
    toastMessages: {
      success: 'De operatie is met succes uitgevoerd',
      error: 'Onverwachte fout. Probeer het later opnieuw.',
      invalid: 'Ongeldige waarden in formulier',
      done: 'Klaar!',
      requestProcessed: 'Het verzoek wordt verwerkt. Een ogenblik alstublieft...',
      noQuestions: 'De training moet minimaal 1 vraag bevatten',
      pointsAdded: 'Boeking gemaakt',
      selectUser: 'Selecteer gebruiker uit de lijst',
      selectOneField: 'Selecteer één veld',
      pointRemoveSoon: 'Punten worden binnenkort verwijderd',
      shopStatsStartImportUser: 'Import starten: Shop Statistieken - GEBRUIKER',
      shopStatsPrepareMissingExportToken: 'Prepare-stap gaf geen export_token terug.',
      shopStatsPrepareInvalidNextChunk: 'Prepare-stap gaf een ongeldige next_chunk terug.',
      shopStatsPrepareUnchangedChunkCursor: 'Prepare-stap gaf ongewijzigde chunk/cursor terug.',
      shopStatsPrepareMaxIterations: 'Prepare-stap overschreed het maximale aantal iteraties.',
      shopStatsConvertInvalidNextSubstep: 'Convert-stap gaf een ongeldige next_substep terug.',
      shopStatsConvertMaxIterations: 'Convert-stap overschreed het maximale aantal iteraties.',
      shopStatsExportInvalidDownloadUrl: 'Export-stap gaf geen geldige download-URL terug.',
      shopStatsDone: 'Klaar',
      shopStatsExportFailed: 'Export mislukt'
    },
    stats: {
      users_list: 'Aantal gebruikers',
      external_trainings_request: 'Externe trainingen',
      product_trainings_request: 'Producttrainingen',
      bridgestone_courses_request: 'BS-opleiding',
      hunter_request: 'Hunter',
      investments_request: 'Investeringssteun',
      orders_list: 'Bestellijst',
      history_list: 'Inloggeschiedenis',
      salespromotions_list: 'Verkooppromoties',
      complaints_list: 'Klachten',
      points_list: 'Puntenlijst',
      kickback_list: 'Bonus in Euro',
      history_hour: 'Login hours',
      tyre_list: 'Banden'
    },
    product_trainings_request: 'Aanvragen voor producttrainingen',
    bridgestone_courses_request: 'BS-trainingsaanvragen',
    attempt_number: 'Poging nummer',
    thirdPartyInvoice: 'Factuur van derden',
    userInvoice: 'Gebruikersfactuur',
    bankAccountOwner: 'bank Account eigenaar',
    open: 'Open',
    appLogo: 'Applicatielogo',
    appURL: 'Applicatie-URL',
    appURLSSOLogin: 'URL na SSO-login',
    url: 'URL',
    url_text: 'URL-tekst',
    choose_posterSide: 'Afbeelding kant: ',
    left: 'Links',
    right: 'Rechts',
    disclaimer: 'Vrijwaring',
    supply: {
      history: 'Leveringsgeschiedenis',
      quantity: 'Hoeveelheid'
    },
    copyAsMain: 'Kopieer als hoofdteaser',
    news_feed_slider_list: 'Lijst met schuifregelaar voor nieuwsfeeds',
    usersPage: {
      boostersToApprove: 'Booster om goed te keuren',
      lastLogin: 'Laatste aanmelding:',
      isPreonboarded: 'Pre-onboarding voltooid',
      isBl: 'Afdelingshoofd',
      customerNumbers: 'Klantnummer(s)',
      branches: 'Vestiging(en)',
      balance: 'Rekeningsaldo',
      orders: 'Bestellingen',
      groups: 'Netwerk',
      notes: 'Opmerkingen',
      salesStaff: 'Verkooppersoneel',
      parentBranch: 'Moedertak',
      childBranch: 'Ondertak',
      addWholesaler: 'Groothandelaar toevoegen',
      addBranch: 'Filiaal toevoegen',
      tooltip: 'Om een filiaal toe te voegen, moet u het klantnummer van het bovenliggende filiaal opslaan',
      tooltipRmCnLocal: 'Lokaal klantnummer verwijderen',
      tooltipRmCnDB: 'Klantnummer verwijderen voor database',
      statement: 'Status',
      bank: {
        date: 'Datum',
        supplySourceReason: 'Distributeur / Bridgestone PLUS',
        customerNumber: 'Klantnr.',
        article: 'Artikel',
        brand: 'Merk',
        product: 'Product',
        type: 'Type',
        dimension: 'Banden-maat',
        inch: 'Omschrijving',
        season: 'Seizoen',
        amount: 'Aantal',
        otherActions: 'Activiteit',
        totalPoints: 'Totaal aantal punten',
        editPoint: 'Punten bewerken',
        deleteManualPointConfirm: 'Weet u zeker dat u deze handmatige puntenboeking ({points} punten, {date}) wilt verwijderen?',
        loadMore: 'Laad nog 20 records',
        showAll: 'Alles tonen',
        seasons: {
          all: 'All season',
          summer: 'Zomer',
          winter: 'Winter',
          general: 'Algemeen'
        },
        advanced: 'Geavanceerd',
        deleteUser: 'Verwijder gebruiker'
      },
      advanced: 'Geavanceerd',
      deleteUser: 'Verwijder gebruiker',
      deleteUserConfirm: 'Weet u zeker dat u de gebruiker wilt verwijderen?',
      deleteUserSuccess: 'De gebruiker is verwijderd.',
      deleteUserNotFound: 'De gebruiker bestaat niet of is al verwijderd.',
      deleteUserDealerConflict:
        'De dealer kan niet worden verwijderd omdat deze actieve klantnummers heeft. Verwijder eerst de gekoppelde klantnummers.',
      deleteUserError: 'Het is niet gelukt om de gebruiker te verwijderen. Probeer het opnieuw.',
      generateTemporaryPassword: 'Tijdelijk wachtwoord genereren',
      generateTemporaryPasswordConfirm:
        'Weet u zeker dat u het wachtwoord voor {user} wilt resetten? Het huidige wachtwoord werkt daarna niet meer.',
      temporaryPasswordGeneratedTitle: 'Tijdelijk wachtwoord gegenereerd',
      temporaryPasswordOneTimeWarning: 'Dit wachtwoord wordt slechts één keer getoond. Kopieer het voordat u dit venster sluit.',
      copyPassword: 'Kopiëren naar klembord',
      passwordCopied: 'Gekopieerd',
      showPassword: 'Wachtwoord tonen',
      hidePassword: 'Wachtwoord verbergen',
      generateTemporaryPasswordForbidden: 'U heeft geen toestemming om een tijdelijk wachtwoord te genereren.',
      generateTemporaryPasswordNotFound: 'Gebruiker bestaat niet.',
      passwordMismatch: 'Wachtwoorden komen niet overeen',
      deleteCustomerNumber: 'Klantnummer verwijderen',
      manageSalesStaff: 'Sales staff beheren',
      availableSalesStaff: 'Beschikbare sales staff',
      assignedSalesStaff: 'Toegewezen sales staff',
      salesStaffTransferHint:
        'Selecteer links of rechts een of meer sales staff-leden. Gebruik de pijlen om ze met deze dealer te koppelen of los te koppelen.',
      transferSalesStaffRight: 'Geselecteerde sales staff koppelen',
      transferSalesStaffLeft: 'Geselecteerde sales staff loskoppelen',
      salesStaffSearchNoResults: 'Geen overeenkomende sales staff gevonden.',
      addSalesStaff: 'Sales staff toevoegen',
      selectSalesStaffToAdd: 'Selecteer sales staff om toe te voegen',
      noSalesStaffAssigned: 'Nog geen sales staff toegewezen.',
      noSalesStaffAvailable: 'Alle beschikbare sales staff zijn al toegewezen.',
      addSalesStaffConfirm: 'Weet u zeker dat u sales staff {salesStaff} aan deze dealer wilt toevoegen?',
      deleteSalesStaffConfirm: 'Weet u zeker dat u sales staff {salesStaff} van deze dealer wilt verwijderen?',
      deleteAddressConfirm: 'Weet u zeker dat u dit adres wilt verwijderen?',
      milestones: {
        targetLabel: 'Doel',
        yearLabel: 'Jaar',
        new: 'Nieuw',
        empty: 'Geen doel voor enig jaar. Maak een nieuwe aan.',
        editTitle: 'Doel bewerken',
        createTitle: 'Doel aanmaken',
        deleteConfirm: 'Weet u zeker dat u de mijlpaal voor doel {target} en jaar {year} wilt verwijderen?',
        targetRequiredInfo: 'Het doel is noodzakelijk voor de correcte berekening van punten voor het geselecteerde jaar.'
      },
      milestonesTab: 'Mijlpalen',
      campaignsTab: 'Campagnes',
      dealerGroupsLabel: 'Dealergroepen',
      preOnboardStatusLabel: 'Pre-onboardstatus',
      extraEmailsTab: 'Extra e-mails',
      customerGroupsLabel: 'Klantgroepen',
      customerGroupsNone: 'Geen',
      showDealersList: 'Dealerlijst tonen',
      staffDealersList: 'Lijst van uw dealers',
      syncSelectedDealers: 'Geselecteerde dealers synchroniseren',
      connectAllDealersFromBs: 'Alle dealers uit BS+ koppelen',
      connectAllDealersConfirmTitle: 'Alle dealers koppelen',
      connectAllDealersConfirmDescription: 'Weet je zeker dat je alle dealers aan deze staff-gebruiker wilt koppelen?',
      disconnectAllDealersConfirmTitle: 'Alle dealers ontkoppelen',
      disconnectAllDealersConfirmDescription: 'Weet je zeker dat je alle dealers van deze staff-gebruiker wilt ontkoppelen?',
      transferDealersToAnotherBsStaff: 'Dealers overzetten naar een andere BS-medewerker',
      showingCount: '{visible} / {total} weergegeven',
      groupDealersSelectedCount: '{selected} geselecteerd',
      groupDealersUnselectedCount: '{unselected} niet geselecteerd',
      showGroupOnly: 'Alleen tonen',
      clearGroupFilter: 'Alle groepen tonen',
      noDealersInSelectedGroups: 'Geen dealers in de geselecteerde groepen',
      downloadConnectedDealers: 'Gekoppelde dealers downloaden',
      showGroupFilters: 'Groepsfilters tonen',
      hideGroupFilters: 'Groepsfilters verbergen',
      staffDealersToolbarSync: 'Synchronisatie',
      staffDealersToolbarBulk: 'Bulkacties',
      staffDealersToolbarExport: 'Export',
      importDealersByEmail: 'Dealers importeren uit Excel',
      importDealersByEmailTitle: 'Dealers importeren via e-mail',
      importDealersByEmailInfo: 'Upload een Excel-bestand (.xlsx, .xls) met alleen e-mailadressen in kolom A.',
      importDealersByEmailHeaderInfo: 'De eerste rij mag de kop "email" bevatten.',
      importDealersByEmailEmptySheet: 'Het Excel-bestand bevat geen gegevens.',
      importDealersByEmailEmptyColumn: 'Kolom A bevat geen e-mailadressen.',
      importDealersByEmailMultipleColumns: 'Het bestand mag slechts één kolom met e-mailadressen bevatten.',
      importDealersByEmailReadError: 'Het Excel-bestand kon niet worden gelezen.',
      importDealersByEmailValidating: 'Bestand valideren...',
      importDealersByEmailSummaryTitle: 'Importoverzicht',
      importDealersByEmailAlreadyConnected: 'Al gekoppeld',
      importDealersByEmailNewConnections: 'Nieuwe koppelingen',
      importDealersByEmailNotFound: 'Niet gevonden in BS+',
      importDealersByEmailInvalidEmails: 'Ongeldig e-mailformaat',
      importDealersByEmailDuplicates: 'Dubbele e-mails in bestand',
      importDealersByEmailSyncButton: 'Koppelen en synchroniseren',
      importDealersByEmailNoNewConnections: 'Alle e-mails uit het bestand zijn al gekoppeld.',
      importDealersByEmailShowingCount: 'Toont {shown} van {total}',
      notesHelpText: 'Moet 8-20 woorden lang zijn.',
      indirectAccessAlert: 'Deze gebruiker heeft beperkte toegang vanwege het INDIRECT-klanttypepad.',
      parentAttributesNotEnabled:
        'Parent attributes kunnen voor deze markt niet worden opgeslagen. Vraag een super admin om deze functie in te schakelen.',
      termsConfirmed: 'Algemene voorwaarden bevestigd',
      privacyConfirmed: 'Privacybeleid bevestigd',
      approvedByBs: 'Goedgekeurd door BS+',
      extraDocsConfirmed: 'Extra documenten voor indirecte klant bevestigd',
      restrictedAccess: 'Beperkte toegang',
      revokeApproval: 'Goedkeuring intrekken',
      approve: 'Goedkeuren',
      allowPointsCalculationConfirm:
        'Do you want to activate/deactivate points calculation for customer number {customerNumber} ({wholesaler})?',
      calculateOneCustomerNumberTitle: 'Calculate points for customer number',
      calculateOneCustomerNumberQuestion: 'Would you like to calculate data for customer number {customerNumber}?',
      calculateOneCustomerNumberWholesaler: 'Wholesaler: {wholesaler}',
      calculateOneCustomerNumberYearLabel: 'Year',
      activateCustomerNumberConfirm: 'Are you sure you want to activate customer number {customerNumber} ({wholesaler})?',
      deactivateCustomerNumberConfirm: 'Are you sure you want to deactivate customer number {customerNumber} ({wholesaler})?',
      saveCustomerNumberConfirm: 'Weet u zeker dat u het klantnummer {customerNumber} ({wholesaler}) wilt opslaan of bijwerken?',
      selectRole: 'Selecteer Rol',
      selectClientType: 'Selecteer klanttype',
      selectWholesaler: 'Selecteer Groothandelaar',
      pointsSummary: {
        year: 'Jaar',
        actions: 'Acties',
        revert: 'Verloop terugdraaien',
        recalculate: 'Verloop herberekenen',
        currentPoints: 'Puntenstand',
        pointsFromCurrentYear: 'Punten uit huidig jaar ({year})',
        atRiskLabel: 'Uit te geven punten t/m 31.03.{year}',
        loadError: 'Kon het puntenoverzicht niet laden.',
        invalidYear: 'Jaar moet een geheel getal tussen 2000 en 3000 zijn.',
        recalculateConfirm: 'Dit verwijdert oude vervalboeking en herberekent die voor jaar {year}. Doorgaan?',
        revertSuccess: 'Verwijderde boekingen: {count}',
        revertConfirm: 'Dit verwijdert vervalboekingen voor jaar {year}. Doorgaan?',
        recalculateSuccess: 'Herberekend. Vervallen punten: {points}',
        recalculateNoop: 'Geen punten om te laten vervallen voor dit jaar.'
      }
    },
    recoverUser: 'Gebruiker ophalen',
    pieces_per_set: 'Verpakkingseenheden',
    new: 'Nieuw',
    all: 'Alle',
    showAddress: 'Adres tonen',
    showGroup: 'Groep tonen',
    showPoints: 'Toon punten',
    showKickbacks: 'Toon bonus in euro',
    external_sales: 'Externe verkoop',
    login_from: 'Laatste login (vanaf)',
    login_to: 'Laatste login (tot)',
    searchUserDownload: {
      title: 'Zoekgegevens downloaden',
      description: 'Kies het bestandsformaat voor de export.',
      formatCsv: 'CSV (.csv)'
    },
    check: 'Rekening',
    reject: 'Afwijzen',
    reason: 'Reden',
    active_by: 'Geactiveerd door',
    sharePassword: 'Deel dit wachtwoord met de nieuwe beheerder',
    activeBtn: 'Nu actief',
    newUserVerify: 'Verificatie van de nieuwe registratie',
    complaintForm: {
      sections: {
        general: {
          title: 'over het algemeen',
          ordinance: 'Verordening van de dealer',
          generalEmail: 'jouw e-mailadres',
          country: 'Land',
          pickupLocation: 'Ophaalplaats'
        },
        regulator: {
          title: 'adres bandendealer - toezichthouder'
        },
        vehicleDetails: {
          title: 'Voertuig details',
          vehicleManufacturer: 'Voertuigfabrikant',
          vehicleModelType: 'Voertuigmodel en typeaanduiding volgens goedkeuring',
          firstRegistration: 'Eerste registratie',
          enginePower: 'Motorvermogen (KW bijv. 150)',
          originalEquipment: 'originele uitrusting',
          tireMilageHours: 'Kilometerstand (km) / bedrijfsuren',
          milageOrHours: 'km of uren (bijvoorbeeld 2000)'
        },
        tyre: {
          tireSizeExample: 'Bandenmaat (bijv. 215/60/16)',
          speedLoadIndex: 'Snelheid / belastingsindex',
          profileDesignation: 'Profielaanduiding incl. Specificatie',
          dot: 'DOT',
          truckSerialNo: 'serienummer. (alleen voor vrachtwagenbanden)',
          complaintReason: 'Klacht redenen',
          isTyreReplaced: 'Zijn de banden al vervangen?',
          ifYesTyre: 'Zo ja, merk reservebanden',
          clerkName: 'Naam griffier',
          complaintReasonText: 'Klacht tekst'
        }
      }
    },
    yesText: 'Ja',
    noText: 'Nee',
    tyre: 'Band',
    maintenance_mode_title: 'Onderhoudsmodus',
    maintenance_mode_description:
      'Weet je zeker dat je wilt doorgaan? Wanneer deze optie is ingeschakeld, is de website tijdelijk niet beschikbaar voor gebruikers.',
    maintenance_mode_disable_title: 'Onderhoudsmodus uitschakelen',
    maintenance_mode_disable_description:
      'Weet je zeker dat je wilt doorgaan? De website wordt weer beschikbaar voor gebruikers.',
    buttons: {
      close: 'Dichtbij',
      send: 'Verzenden',
      validateFile: 'Bestand valideren',
      back: 'Terug',
      placeOrder: 'Bindende bestelling',
      download: 'Downloaden',
      downloadData: 'Gegevens downloaden',
      downloadSearchResults: 'Zoekgegevens downloaden',
      openDownloadModal: 'Downloadgegevens-modal openen',
      loading: 'Laden',
      approve: 'Goedkeuren',
      deleteOrder: 'Bestelling verwijderen',
      archive: 'Archief',
      acceptAll: 'Accepteer alles',
      advanceSearch: 'Geavanceerd zoeken',
      addMenu: 'Menu toevoegen',
      setMaintenance: 'Onderhoud instellen',
      hideMaintenance: 'Onderhoud verbergen',
      deactivate: 'Deactiveren',
      importSelected: 'Geselecteerd importeren',
      startOver: 'Opnieuw beginnen',
      loadMore: 'Meer laden',
      loadAll: 'Alles laden',
      clearFilters: 'Filter zurücksetzen',
      toSearch: 'Search',
      delete: 'Delete',
      importArticleNumbers: 'Importeer deze items',
      allowAccessToUsers: 'Toegang tot groep van gebruikers toestaan'
    },
    others: 'Anderen',
    archive_training_title: 'Training archiveren',
    archive_training: 'Wil je deze training echt archiveren?',
    delete_menu: 'Do you wanna delete menu item?',
    no_entries: 'Geen toegang',
    external_url: 'Externe URL',
    incomplete_address: 'Adres is onvolledig. Gelieve dit na te kijken',
    request_from: 'Aanvraag van',
    let_see_points: 'Laat de gebruiker marketingpunten zien',
    let_see_kickback: 'Laat de gebruiker de bonus zien',
    major: 'Groep',
    customer_group: 'Groep',
    media_category: 'Mediacategorie',
    dragHere: 'Zet de bestanden hier neer...',
    dragDropSelectFiles: 'Sleep hier bestanden naartoe of klik om bestanden te selecteren',
    publicFileUploadWarning:
      'Geuploade bestanden zijn openbaar toegankelijk. Als openbare of gevoelige gegevens per ongeluk worden gedeeld, kan de gebruiker hierdoor ernstige problemen krijgen. Uploaden gebeurt op eigen verantwoordelijkheid.',
    uploadingFiles: 'Bestanden uploaden',
    uploadingCurrentFile: 'Huidig bestand',
    allCategories: 'Alle categorieen',
    addEmbbeded: 'Voeg ingesloten code toe',
    canReceivePoints: 'Kan punten ontvangen',
    canUsePoints: 'Kan punten gebruiken',
    wholesaler_management: {
      modal: {
        description: 'Welke gegevens kan de groothandel in dealergegevens zien?'
      }
    },
    personalData: 'Persoonsgegevens',
    operatingData: 'Belangrijkste operationele cijfers',
    orderDelivery: 'Bedrijfsgegevens',
    diffDeliveryAddres: 'Afleveradres toevoegen',
    salesRepresentative: 'Sales Representative',
    status_iban: 'Status IBAN',
    iban: 'IBAN',
    show_export_user_iban: 'Users Dealer Iban',
    do_match: 'Change to Match',
    iban_status: {
      nameMatchResult: {
        MATCH: 'when the provided name matches the value of the account holder name held by the source',
        CLOSE_MATCH: '<b>when the provided name closely resembles the value of the account holder name held by the source</b>',
        NO_MATCH: '<b>when the provided name does not match the value of the account holder name held by the source</b>',
        COULD_NOT_MATCH: '<b>when the provided name could not be matched against the source data</b>',
        NAME_TOO_SHORT:
          '<b>when the provided name is too short to perform a match against the value of the account holder name held by the source</b>'
      },
      dataUsedForMatching: {
        VERIFIED: 'Verified is the data that exists at the beneficiary bank',
        DERIVED: '<b>Derived is data based on historical transactions</b>'
      },
      accountNumberValidation: {
        VALID: 'An account that conforms to the standards, e.g. a valid Mod97 calculation for an IBAN',
        NOT_VALID: '<b>account is an account that does not conform to the standards</b>'
      },
      paymentPreValidation: {
        PASS: 'is returned when the account identification was successfully validated to an account that can receive funds',
        WILL_FAIL: '<b>is returned if the payment will definitely fail</b>',
        WARNING:
          '<b>is returned in case the account identification was not successfully validated to an account that can receive funds, however, the responding bank is unable to provide a definitive answer</b>'
      },
      status: {
        ACTIVE: 'Account is a valid account and supported for checks',
        INACTIVE:
          '<b>Account is a valid account marked as inactive by the account holding bank, by a third party or by SurePay if SurePay has reason to believe that the account should be marked as inactive</b>',
        NOT_SUPPORTED: '<b>Account status stands for an account that is valid but is not supported to perform any checks</b>',
        NOT_FOUND:
          '<b>Account status stands for an account that is valid but could not be found in any of the connected data sources</b>',
        UNKNOWN: '<b>Account status is for an account that is either found as part of DERIVED data or a NOT_VALID account</b>'
      }
    },
    current_tyres_amount: 'Banden hoeveelheid',
    current_points: 'Puntensaldo',
    current_kickbacks: 'Kick-back',
    change_role_info:
      'Als u een rol in het <b>Bridgestone PLUS-System</b> wijzigt, worden verbindingen verwijderd die aan een bepaalde rol zijn gekoppeld. Zo worden bijvoorbeeld punten, klantnummers, verbindingen tussen een Bridgestone-agent en een dealer, bestellingen, enz. verwijderd. Omdat er geen weg terug is?',
    firstRegistration: 'Eerste registratie',
    mediaCategories: {
      products: 'Producten',
      brand_and_solutions: 'Merk & Oplossingen',
      season_and_promotions: 'Seizoen & Acties',
      format: 'Formaat',
      cars_and_vans: "Personenauto's & Bestelwagens",
      truck_and_buses: 'Vrachtwagens & Bussen',
      motorcycle: 'Motorfiets',
      agriculture: 'Landbouw',
      construction_machinery: 'Bouwmachines',
      bridgestone: 'Bridgestone',
      firestone: 'Firestone',
      bandag: 'Bandag',
      bleetcare: 'Fleet Care',
      webfleet: 'Webfleet',
      summer: 'Zomer',
      winter: 'Winter',
      all_season: 'Alle seizoenen',
      promotions: 'Promoties',
      video_in_store: 'Video met ondertitels',
      video_online: 'Video zonder ondertitels',
      banner_website: 'Banner',
      banner_social_media: 'Sociale media',
      logos: "Logo's",
      b_drive: 'B-drive',
      media_library: 'Mediatheek',
      media_packages: 'Mediapakketten',
      material: 'Materialen',
      price_list: 'Prijslijsten',
      brochures: 'Productbrochures',
      price: 'Pricat',
      oe: 'OE',
      allSeason: 'Vierseizoenen',
      trucks: 'Vrachtwagens',
      technology: 'Technologie',
      allseason: 'Vierseizoenen',
      season: 'Seizoen'
    },
    fileType: {
      label: 'File type',
      video: 'Video',
      image: 'Image',
      embeded: 'Embeded',
      pdf: 'PDF'
    },
    deleteMediaModal: {
      title: 'Delete media collection',
      description: "Do you confirm delete file's collection? It will delete all connect files.",
      filesLabel: 'Bestanden die worden verwijderd',
      noFiles: 'Geen bestanden in deze collectie'
    },
    deleteMediaFileModal: {
      title: 'Delete file from collection',
      description: 'Do you want to you delete file from this collection?'
    },
    deleteBrochureFileModal: {
      title: 'Bestand uit collectie verwijderen',
      description: 'Wil je het bestand "{fileName}" uit deze collectie verwijderen?',
      fileNameFallback: 'Onbekend bestand'
    },
    deleteBrochureModal: {
      title: 'Brochure verwijderen',
      description: 'Weet je zeker dat je brochure "{name}" wilt verwijderen?',
      nameFallback: 'Onbekende brochure',
      filesLabel: 'Bestanden die worden verwijderd',
      noFiles: 'Geen bestanden in deze brochure'
    },
    languages: {
      aa: 'Afar',
      ab: 'Abchazisch',
      ae: 'Avestisch',
      af: 'Afrikaans',
      ak: 'Akan',
      am: 'Amhaars',
      an: 'Aragonees',
      ar: 'Arabisch',
      as: 'Assamees',
      av: 'Avarisch',
      ay: 'Aymara',
      az: 'Azerbeidzjaans',
      ba: 'Basjkiers',
      be: 'Belarussisch',
      bg: 'Bulgaars',
      bh: 'Bhojpuri',
      bi: 'Bislama',
      bm: 'Bambara',
      bn: 'Bengaals',
      bo: 'Tibetaans',
      br: 'Bretons',
      bs: 'Bosnisch',
      ca: 'Catalaans',
      ce: 'Tsjetsjeens',
      ch: 'Chamorro',
      co: 'Corsicaans',
      cr: 'Cree',
      cs: 'Tsjechisch',
      cu: 'Kerkslavisch',
      cv: 'Tsjoevasjisch',
      cy: 'Welsh',
      da: 'Deens',
      de: 'Duits',
      dv: 'Divehi',
      dz: 'Dzongkha',
      ee: 'Ewe',
      el: 'Grieks',
      en: 'Engels',
      eo: 'Esperanto',
      es: 'Spaans',
      et: 'Estisch',
      eu: 'Baskisch',
      fa: 'Perzisch',
      ff: 'Fulah',
      fi: 'Fins',
      fj: 'Fijisch',
      fo: 'Faeröers',
      fr: 'Frans',
      fy: 'Fries',
      ga: 'Iers',
      gd: 'Schots-Gaelisch',
      gl: 'Galicisch',
      gn: 'Guaraní',
      gu: 'Gujarati',
      gv: 'Manx',
      ha: 'Hausa',
      he: 'Hebreeuws',
      hi: 'Hindi',
      ho: 'Hiri Motu',
      hr: 'Kroatisch',
      ht: 'Haïtiaans Creools',
      hu: 'Hongaars',
      hy: 'Armeens',
      hz: 'Herero',
      ia: 'Interlingua',
      id: 'Indonesisch',
      ie: 'Interlingue',
      ig: 'Igbo',
      ii: 'Yi',
      ik: 'Inupiaq',
      io: 'Ido',
      is: 'IJslands',
      it: 'Italiaans',
      iu: 'Inuktitut',
      ja: 'Japans',
      jv: 'Javaans',
      ka: 'Georgisch',
      kg: 'Kongo',
      ki: 'Gikuyu',
      kj: 'Kuanyama',
      kk: 'Kazachs',
      kl: 'Groenlands',
      km: 'Khmer',
      kn: 'Kannada',
      ko: 'Koreaans',
      kr: 'Kanuri',
      ks: 'Kasjmiri',
      ku: 'Koerdisch',
      kv: 'Komi',
      kw: 'Cornish',
      ky: 'Kirgizisch',
      la: 'Latijn',
      lb: 'Luxemburgs',
      lg: 'Luganda',
      li: 'Limburgs',
      ln: 'Lingala',
      lo: 'Laotiaans',
      lt: 'Litouws',
      lu: 'Luba-Katanga',
      lv: 'Lets',
      mg: 'Malagassisch',
      mh: 'Marshallees',
      mi: 'Maori',
      mk: 'Macedonisch',
      ml: 'Malayalam',
      mn: 'Mongools',
      mr: 'Marathi',
      ms: 'Maleis',
      mt: 'Maltees',
      my: 'Birmaans',
      na: 'Nauruaans',
      nb: 'Noors - Bokmål',
      nd: 'Noord-Ndebele',
      ne: 'Nepalees',
      ng: 'Ndonga',
      nl: 'Nederlands',
      nn: 'Noors - Nynorsk',
      no: 'Noors',
      nr: 'Zuid-Ndbele',
      nv: 'Navajo',
      ny: 'Nyanja',
      oc: 'Occitaans',
      oj: 'Ojibwa',
      om: 'Afaan Oromo',
      or: 'Odia',
      os: 'Ossetisch',
      pa: 'Punjabi',
      pi: 'Pali',
      pl: 'Pools',
      ps: 'Pasjtoe',
      pt: 'Portugees',
      qu: 'Quechua',
      rm: 'Reto-Romaans',
      rn: 'Kirundi',
      ro: 'Roemeens',
      ru: 'Russisch',
      rw: 'Kinyarwanda',
      sa: 'Sanskriet',
      sc: 'Sardijns',
      sd: 'Sindhi',
      se: 'Noord-Samisch',
      sg: 'Sango',
      si: 'Singalees',
      sk: 'Slowaaks',
      sl: 'Sloveens',
      sm: 'Samoaans',
      sn: 'Shona',
      so: 'Somalisch',
      sq: 'Albanees',
      sr: 'Servisch',
      ss: 'Swazi',
      st: 'Zuid-Sotho',
      su: 'Soendanees',
      sv: 'Zweeds',
      sw: 'Swahili',
      ta: 'Tamil',
      te: 'Telugu',
      tg: 'Tadzjieks',
      th: 'Thai',
      ti: 'Tigrinya',
      tk: 'Turkmeens',
      tl: 'Filipijns',
      tn: 'Tswana',
      to: 'Tongaans',
      tr: 'Turks',
      ts: 'Tsonga',
      tt: 'Tataars',
      tw: 'Akan',
      ty: 'Tahitiaans',
      ug: 'Oeigoers',
      uk: 'Oekraïens',
      ur: 'Urdu',
      uz: 'Oezbeeks',
      ve: 'Venda',
      vi: 'Vietnamees',
      vo: 'Volapük',
      wa: 'Waals',
      wo: 'Wolof',
      xh: 'Xhosa',
      yi: 'Jiddisch',
      yo: 'Yoruba',
      za: 'Zhuang',
      zh: 'Chinees',
      zu: 'Zoeloe',
      at: 'Duits',
      cz: 'Tsjechisch',
      'fr-FR': 'Frans',
      'fr-BE': 'Frans',
      'nl-BE': 'Nederlands'
    },
    colleague: 'medewerker',
    tradeInDate: 'Inruildatum',
    vouchers: {
      id: 'ID',
      code: 'Code',
      colleagueName: 'Naam medewerker',
      dealerName: 'Naam dealer',
      download: 'Downloaden',
      points: 'Aantal punten per voucher',
      amount: 'Aantal vouchers',
      deleteConfirmTitle: 'Voucher verwijderen',
      deleteConfirmDescription: 'Weet je zeker dat je deze voucher wilt verwijderen?'
    },
    selectText: 'Selecteer',
    brochureCategories: {
      products: 'Producten',
      brand_and_solutions: 'Merk & Oplossingen',
      season_and_promotions: 'Seizoen & Promoties',
      format: 'Formaat',
      cars_and_vans: 'Personenwagens en bestelwagens',
      truck_and_buses: 'Vrachtwagens en bussen',
      motorcycle: 'Motorfiets',
      agriculture: 'Landbouw',
      construction_machinery: 'Bouwmachines',
      bridgestone: 'Bridgestone',
      firestone: 'Firestone',
      bandag: 'Bandag',
      bleetcare: 'Fleetcare',
      webfleet: 'Webfleet',
      material: 'Materialen',
      brochures: 'Brochures',
      price_list: 'Prijslijst',
      materials: 'materialen',
      summer: 'Zomer',
      winter: 'Winter',
      all_season: 'Vierseizoenen',
      trucks: 'Vrachtwagens',
      technology: 'Technologie',
      oe: 'OE',
      allSeason: 'Vierseizoenen',
      season: 'Seizoen',
      promotions: 'Promoties'
    },
    survey: {
      new: 'Nieuwe enquête',
      edit: 'Enquête bewerken',
      name: 'Naam',
      title: 'Titel',
      description: 'Beschrijving',
      url: 'Url van Hello Customer Stand-alone Survey',
      return_url: 'Retourlink om in te voegen in Hello Customer Backend',
      user_email: 'E-mail',
      user_first_name: 'Voornaam',
      user_last_name: 'Achternaam',
      user_gender: 'Geslacht',
      user_customer_number: 'Klantnummer',
      user_whs: 'Whs',
      user_zip_code: 'Postcode',
      has_rewards: 'Beloning enquêtedeelname',
      user_information: 'Selectie van gebruikersinformatie die moet worden verzonden naar Hello Customer',
      points: 'points',
      surveys_activated: 'Geactiveerde enquêtes',
      select_surveys_activated: 'Selecteer een geactiveerde enquête'
    },
    deleteMainBox: {
      title: 'Hoofdvak verwijderen',
      description: 'Weet u zeker dat u dit item wilt verwijderen?'
    },
    apps: {
      app_new: 'Nieuwe app',
      title: 'Applicaties',
      name: 'Naam',
      code: 'Code',
      ownerName: 'Naam eigenaar',
      ownerEmail: 'E-mailadres eigenaar',
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      chooseFile: 'Bestand kiezen',
      noFileSelected: 'Geen bestand geselecteerd',
      tabDetails: 'Details',
      tabBusinessUnits: 'Business Units',
      tabLocalizedContent: 'Gelokaliseerde inhoud',
      tabOwners: 'App-eigenaren',
      isVisibleEveryone: 'Open toegang',
      isSSOReady: 'SSO',
      relationDirect: 'Direct',
      relationInDirect: 'Indirect',
      clientType: 'Klanttype',
      clientTypeEveryone: 'Iedereen',
      clientTypeDirect: 'Direct',
      clientTypeIndirect: 'Indirect',
      clientTypeDirectIndirect: 'Direct + Indirect',
      isVisibleEveryoneLabel:
        'Indien ingeschakeld, is toegang open voor alle gebruikers die overeenkomen met de zichtbaarheidsinstellingen hieronder. Indien uitgeschakeld, is toegang beperkt en moet deze handmatig per gebruiker in het gebruikersprofiel of via upload van een gebruikerslijst worden toegekend.',
      isSSOReadyLabel: 'Is SSO gereed?',
      relationDirectLabel: 'Directe klanten',
      relationInDirectLabel: 'Indirecte klanten',
      removeOwner: 'Verwijderen',
      addNextOwner: 'Volgende eigenaar toevoegen',
      saveOwners: 'Eigenaren opslaan',
      local_app: 'Lokale app',
      managed_globally_info: 'Deze applicatie wordt beheerd door de Global Admin'
    },
    bsPlus: {
      onboarding: {
        title: "Welkom bij Bridgestone <span class='text-danger'>PLUS</span>",
        termsAndConditions: 'Algemene voorwaarden',
        accept: 'Accepteren',
        decline: 'Weigeren',
        dataModal:
          'Om dit aanbod op uw interesses af te stemmen, vragen we u kort uw productinteresses of bedrijfsactiviteiten aan te geven.',
        scrollToAccept: 'Scroll naar beneden om onze voorwaarden te accepteren en door te gaan',
        welcomeMessage: 'Welkom bij Bridgestone Plus',
        tailorOffer:
          'Om dit aanbod op uw interesses af te stemmen, vragen we u kort uw productinteresses of bedrijfsactiviteiten aan te geven.',
        bussinessType:
          'Om dit aanbod op uw interesses af te stemmen, vragen we u kort uw productinteresses of bedrijfsactiviteiten aan te geven.',
        selectAreas: 'Selecteer uit de volgende gebieden',
        multipleAnswers: '(Meerdere antwoorden mogelijk):',
        personalPreferences: 'Persoonlijke voorkeuren',
        carTyres: "Banden voor auto's, SUV's en bedrijfsvoertuigen",
        motorcyclesTyres: 'Banden voor motorfietsen',
        truckBusTyres: 'Banden voor vrachtwagens en bussen',
        agricultureTyres: 'Banden voor landbouwvoertuigen',
        otrTyres: 'OTR-banden',
        save: 'Opslaan',
        businessRelationship: 'Wat is uw zakelijke relatie met Bridgestone?',
        selectRelationship: 'Selecteer*:',
        tradingPartner: 'Ik ben een handelspartner die...',
        tradingPartnerDirect: '... rechtstreeks bij Bridgestone bestelt',
        tradingPartnerIndirect: '... indirect bestelt (bijv. via de groothandel)',
        tradingPartnerBoth: '... zowel rechtstreeks als indirect bestelt',
        fleetResponsibleDirect: 'Ik ben een wagenparkverantwoordelijke die...',
        fleetResponsibleIndirect: '... indirect bestelt (via handel of groothandel)',
        fleetResponsibleBoth: '... rechtstreeks en indirect bestelt',
        noBusinessRelationship: '<b>Ik heb geen zakelijke relatie met Bridgestone</b> (noch direct noch indirect)',
        yourCustomerNumber: 'Uw Bridgestone-klantnummer*:',
        enterCustomerNumber: 'Voer uw klantnummer in',
        waitPersonalisedView: 'Even geduld, uw gepersonaliseerde weergave van BRIDGESTONE PLUS wordt gegenereerd.',
        personalised: 'GEPERSONALISEERD',
        plusInfo: 'Hier vindt u informatie over uw Plus-account en uw Plus-inbox.',
        continue: 'Doorgaan',
        skip: 'Overslaan',
        oneOfTwo: '1 van 2',
        openApps:
          'U kunt de apps waarvoor u al geregistreerd bent direct openen. U kunt ook toegang aanvragen tot andere apps die voor u relevant kunnen zijn.',
        requiredFields: 'Vul de verplichte velden in: Titel, Voornaam, Achternaam',
        stage: 'Stap',
        chooseOne: '(Selecteer ten minste een vakje)',
        required: '*Verplichte velden',
        lengthCsNumber: 'Lengte klantnummer: 6-10 cijfers',
        waitForAdminApproval:
          'Bedankt voor uw aanmelding voor het Bridgestone Plus Rewards-programma. We beoordelen momenteel uw aanvraag. U ontvangt een bevestigingsmail zodra uw aanvraag is goedgekeurd.',
        selectTyres: 'ACTIVITEITSGEBIED EN PROFIEL'
      }
    },
    anyLogin: 'elke login',
    frontend_menu: {
      account: 'Profiel',
      plus: 'Over Bridgestone Plus',
      salesSupport: 'Verkoopondersteuning',
      mailbox: 'Mailbox',
      about: 'Over Bridgestone Plus',
      trainingAndCourses: 'Online trainingen',
      externalTraining: 'Externe trainingen',
      productInfo: 'Productinformatie',
      productBrochures: 'Brochures',
      priceLists: 'Prijslijst',
      price: 'Prijs',
      complaintForm: 'Klachtenformulier',
      sales_support: 'Verkoopondersteuning',
      contact_service: 'Contact & Service',
      logOut: 'Uitloggen',
      news: 'Nieuwsfeeds',
      news_feeds: 'Nieuwsfeeds',
      service_number: 'Contact & Service',
      brochure_prices: 'Brochures en prijslijst',
      trainings: 'Trainingen',
      salesPromotions: 'Verkooppromoties',
      stammdaten: 'Mijn profiel',
      onlineTrainings: 'Online trainingen',
      shop: 'Winkel',
      preislisten: 'Prijslijst',
      medias: 'Media',
      media: 'Media',
      manageLinks: 'Menulinks beheren',
      noModuleLinksAvailable: 'Geen modulelinks beschikbaar voor deze tenant.'
    },
    customerNumbersAssistant: {
      date: {
        title: 'Bereken punten vanaf datum X'
      },
      import: {
        openButton: 'Klantnummers importeren',
        loadingModal: 'Modal wordt geladen...',
        title: 'Klantnummers importeren uit Excel',
        validateButton: 'Bestand valideren',
        submitButton: 'Naar API verzenden',
        submitButtonLoading: 'Bezig met verzenden...',
        selectWholesalerLabel: 'Groothandel',
        selectGroupLabel: 'Groep',
        selectWholesalerPlaceholder: 'Groothandel selecteren',
        selectGroupPlaceholder: 'Groep selecteren (optioneel)',
        requirementsTitle: 'Bestandsvereisten',
        fileFormatRequirement: 'Alleen Excel-bestand: .xlsx of .xls',
        headerRequirement: 'De kopregel moet zijn: Customer number, Email (kolommen A/B).',
        createdLabel: 'Aangemaakt',
        alreadyExistsLabel: 'Bestond al',
        success: 'Excel-bestand is geldig.',
        previewTitle: 'Voorbeeld',
        previewCount: '{count} rijen, {pageSize} rijen per pagina.',
        columnOne: 'Kolom 1',
        columnTwo: 'Kolom 2',
        previousPage: 'Vorige',
        nextPage: 'Volgende',
        pageInfo: 'Pagina {current} / {total}',
        progressLabel: 'Voortgang',
        errors: {
          wholesalerRequired: 'Groothandel is verplicht.',
          groupRequired: 'Groep is verplicht.',
          fileRequired: 'Excel-bestand is verplicht.',
          emptyWorkbook: 'Excel-werkmap is leeg.',
          invalidHeaders: 'Bestand moet precies 2 kolommen bevatten: klantnummer en e-mail.',
          emptyRows: 'Bestand bevat geen gegevensrijen.',
          firstTwoColumnsRequired: 'Rij {row}: de eerste en tweede kolom moeten ingevuld zijn.',
          invalidCustomerNumber: 'Ongeldig klantnummer op rij {row}. Gebruik alleen letters en cijfers.',
          invalidEmail: 'Ongeldig e-mailadres op rij {row}.',
          invalidFileType: 'Alleen Excel-bestanden (.xlsx, .xls) zijn toegestaan.',
          readError: 'Kan Excel-bestand niet lezen.',
          submitFailed: 'Verzenden van records naar API mislukt.'
        }
      }
    },
    product_sync: {
      syncEnabled: 'Synchronisatie ingeschakeld',
      syncDisabled: 'Synchronisatie uitgeschakeld',
      syncDisable: 'Bijwerken via API',
      syncEnable: 'Handmatige productupdate',
      notAvailableDisable: 'Niet zichtbaar in de shop',
      notAvailableEnable: 'Zichtbaar in de shop',
      notAvailableDisabled: 'Niet zichtbaar in de shop',
      notAvailableEnabled: 'Zichtbaar in de shop',
      notAvailableError: 'Fout: niet beschikbaar',
      syncError: 'Synchronisatiefout',
      tooltip: {
        syncEnable:
          'Houd er rekening mee dat de handmatige productupdate alleen geldt voor prijs- en puntenbeheer. Alle andere productinformatie wordt bijgewerkt via de API en kan niet door de lokale beheerder worden aangepast.',
        notAvailableEnable: 'Markeer het product als niet beschikbaar voor deze markt.',
        notAvailableDisable: 'Maak het product opnieuw beschikbaar voor deze markt.'
      }
    },
    category_sync: {
      syncEnabled: 'Afbeeldingssynchronisatie ingeschakeld',
      syncDisabled: 'Afbeeldingssynchronisatie uitgeschakeld',
      syncDisable: 'Afbeelding bijwerken via API',
      syncEnable: 'Handmatige afbeeldingsupdate',
      syncError: 'Fout bij afbeeldingssynchronisatie',
      tooltip: {
        syncEnable:
          'Het uitschakelen van de synchronisatie geldt alleen voor de categorie-afbeelding. Naam, beschrijving en status komen nog steeds uit de globale catalogus. Zolang de afbeeldingssynchronisatie is ingeschakeld, wordt de afbeelding uit de globale catalogus gehaald en kan deze niet lokaal worden gewijzigd.'
      }
    },
    priceCategories: {
      pkw: 'Pkw, 4x4 en bestelwagens',
      motorcycles: 'Motorfietsen',
      trucksAndBuses: 'Vrachtwagens en bussen',
      agriculture: 'Landbouw',
      constructionMachineryOtr: 'Bouwmachines OTR'
    },
    campaigns: {
      title: 'Campagnes',
      new: 'Nieuwe campagne',
      edit: 'Campagne bewerken',
      name: 'Campagnenaam',
      subtitle: 'Campagne subtitel (optioneel)',
      description: 'Beschrijving',
      type: 'Campagnetype',
      selectType: 'Selecteer campagnetype',
      periodName: 'Periodenaam',
      startDate: 'Startdatum',
      endDate: 'Einddatum',
      newPeriod: 'Nieuwe periode',
      image: 'Afbeelding',
      url: 'URL',
      active: 'Actief',
      types: {
        'performance-speedy': 'Performance',
        'performance-cd': 'Performance CD',
        'booster-ccs': 'Booster CCS'
      },
      transferDealersModal: {
        openButton: 'Dealers naar een andere campagne verplaatsen',
        title: 'Campagne selecteren',
        description: 'Je kunt dealers van de huidige campagne {campaignName} naar een andere campagne verplaatsen.',
        loadingCampaigns: 'Campagnes worden geladen...',
        selectCampaignPlaceholder: 'Campagne selecteren',
        submit: 'Verzoek verzenden',
        sending: 'Bezig met verzenden...',
        requestSent: 'Verzoek verzonden',
        requestFailed: 'Verzoek verzenden mislukt'
      },
      alert: {
        title: 'Bevestigen',
        desc: 'Weet je zeker dat je deze campagne wilt verwijderen?'
      }
    },
    marketingConsents: {
      pageTitle: 'Marketingtoestemmingen',
      title: 'Titel',
      status: 'Status',
      noConsents: 'Geen marketingtoestemmingen beschikbaar',
      enabled: 'Ingeschakeld',
      disabled: 'Uitgeschakeld',
      enable: 'Inschakelen',
      disable: 'Uitschakelen',
      enableTitle: 'Marketingtoestemming inschakelen',
      enableMessage: 'Weet u zeker dat u deze marketingtoestemming wilt inschakelen?',
      disableTitle: 'Marketingtoestemming uitschakelen',
      disableMessage: 'Weet u zeker dat u deze marketingtoestemming wilt uitschakelen?',
      toggleSuccess: 'De status van de marketingtoestemming is succesvol bijgewerkt',
      toggleError: 'Er is een fout opgetreden bij het bijwerken van de marketingtoestemming',
      consentType: 'Toestemmingstype',
      selectType: 'Selecteer type...',
      typeChanged: 'Toestemmingstype succesvol bijgewerkt',
      typeChangeError: 'Fout bij het bijwerken van het toestemmingstype',
      visibleFrom: 'Zichtbaar vanaf',
      notYetVisible: 'Nog niet zichtbaar',
      alwaysVisible: 'Altijd zichtbaar'
    }
  },
  wholesaler_management: {
    modal: {
      description: 'Welke gegevens kan de groothandel in dealergegevens zien?'
    }
  }
}
